/**
 * Created by dyc on 2018/4/7.
 */
import React from 'react';
import Reflux from 'reflux';
import {
    Button,
    Row,
    Col,
    Modal,
    Input,
    message,
    Select,
    InputNumber,
    DatePicker,
    Table,
    Icon,
    Upload,
    Card,
    Tooltip,
    Cascader,
    Checkbox,
    Tag,
    Notification
} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from '../../components';
import {
    getPro,
    getPro2,
    getPro3,
    create,
    getDetail,
    getDongList,
    getOrderDetails,
    createForSave,
    giveBefore, getPro4, getPro5, giveTeJia, giveTeJia2, updateOrderLineAttribute
} from '../../service/order';
import moment from 'moment';
import './order.css';
import fenPi from './fenpi.png';
import {openNotice, downLoadTemplate, toImportExcel1} from 'Utils';
import {getGdList} from "../../service/shoppingCar";
import {treeList2} from "../../service/org";

const Option = Select.Option;
const confirm = Modal.confirm;
const {TextArea} = Input;

class QualityAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            button_limits_end: {},
            passId: '',
            /*获取登录人信息数据*/
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || '',
            /*获取详情所需code*/
            purchaseId: JSON.parse(window.sessionStorage.getItem('purchaseId') || '{}') || '',
            /*获取生成订单数据*/
            orderData: JSON.parse(window.sessionStorage.getItem('generate_orders') || '{}') || '',
            /*获取订单商品列表*/
            orderListData: JSON.parse(window.sessionStorage.getItem('list_orders') || '{}') || '',
            passParse: JSON.parse(window.sessionStorage.getItem('passParse') || '{}') || '',
            /*获取预定制列表*/
            dingPassParse: JSON.parse(window.sessionStorage.getItem('dingPassParse') || '{}') || '',
            deliveryShowprice: JSON.parse(window.sessionStorage.getItem('generate_orders')) ? JSON.parse(window.sessionStorage.getItem('generate_orders')).deliveryShowprice : '',
            opts: ['订单详情 -- 新增合作伙伴订单'],
            orderSubmit3: 'bolck',
            orderSubmit2: 'none',
            orderSubmit4: 'none',
            key: 0,
            visible: false,
            visible2: false,
            visible3: false,
            visible4: false,
            modalVisible: false,
            usable: true,
            detailData: {},    //获取的用户信息
            optionAddress: [],    //获取的收货地址（下拉选择）
            tiAddress: [],    //获取的提货地址（下拉选择）
            optionTerminal: [],    //获取的项目信息（含终端）（下拉选择）
            // optionTerminal2: [],    //获取的订单类型（含终端）（下拉选择）
            remark: '',    //输入的备注信息
            valueRemark: [],    //输入的备注信息
            viewCount: '',
            customerOrderCode: '',      //输入的客户订单号
            customerProjectMsg: '',     //客户项目信息
            gatherRealityAddress: '',  //实际收货地址选中
            gatherRealityAddress2: '',  //实际收货地址选中
            terminalMessage: '',
            tiAddress2: '',
            projectMessage: '',     //项目信息（含终端）选中
            addRows: [],
            addRows2: [],
            addRows3: [],
            addRows4: [],
            addRows5: [],
            addTotal: 1,
            addTotal2: 1,
            addTotal3: 1,
            addTotal4: 1,
            addTotal5: 1,
            selectedRowKeys: [],
            selectedRowKeys2: [],
            selectedRowKeys3: [],
            selectedRowKeys4: [],
            selectedRowKeys5: [],
            selectedRowKeysOutside: [],
            selectedRowKeysOutside2: [],
            name: '',
            stockType: '',
            code: '',
            //李新增
            lastsearch: '',
            addSearchObj: {
                s: 10,
                p: 1
            },
            addSearchObj2: {
                s: 10,
                p: 1
            },
            addSearchObj3: {
                s: 10,
                p: 1
            },
            addSearchObj4: {
                s: 10,
                p: 1
            },
            addSearchObj5: {
                s: 10,
                p: 1
            },
            submitRows: [],
            add: [],
            rows: [],
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            day: [],
            productionCycle: [],
            date: [],
            xiaFuJia: [],
            jcxf: [],
            weiFaYunCount: [],
            priceRate: [],
            defDeliverDay: [],
            productName: [],
            onhand: [],
            cadreRepertory: [],
            xinzengShow: false,
            shouHuoShow: false,
            cityShow: true,
            allPrice: 0,
            realyPrice: 0,
            cutPrice: 0,
            dataSource2: [],
            number2: 1,
            count2: 1,
            giveBackStatus: 0,
            // defDiscount:JSON.parse(window.sessionStorage.getItem('generate_orders') || '{}').defDiscount || '',
            defDiscount: 0,
            id6: false,
            confirmvisible: false,
            confirmLoading: false,
            quickVisible: false,
            quickString: '',//智能输入内容
            quickResult: [],
            quickLoading: false,
            cascaderValue: [],
            tree: [],
            ts_disabled: false,
            ts_checked: false,
            ls_checked: false,
            proDetailType: "",
            gsChannelCode: "",
            loading: false,
            apiFlag: true,
            wholeDelivery: 'N', //整单发货
            getTjList: [],
            vipOrderFlag: '',//合作伙伴订单开单权限
            businessLines: [],//业务线集合
            cooperateBusiness: '', //配合业务线
            zdBusiness: '',//终端业务线
            projectBusiness: '',//项目业务线
            finalBusiness: ''//众业达单位业务线
        };
        this.price = this.price.bind(this);
    }

    quickChange = (event) => {
        this.setState({
            quickString: event.target.value
        });
    }

    handleCancel7 = () => {
        this.setState({quickVisible: false});
    }

    getData() {
        treeList2('').then(result => {
            if (result.status) {
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].value = result.data[i].code
                    for (var j = 0; j < result.data[i]['children'].length; j++) {
                        result.data[i]['children'][j].value = result.data[i]['children'][j].code
                        for (var z = 0; z < result.data[i]['children'][j]['children'].length; z++) {
                            result.data[i]['children'][j]['children'][z].value = result.data[i]['children'][j]['children'][z].code;
                            delete result.data[i]['children'][j]['children'][z].children;
                        }
                    }
                }
                this.setState({
                    tree: result.data
                })
            } else {
                openNotice('warning', result.message);
            }
        })
    }

    CascaderClick() {
        if (this.state.tree == null || this.state.tree == '') {
            this.getData();
        }
    }

    CascaderRender = (label) => {
        return label[label.length - 1];
    }


    CascaderFilter = (inputValue, path) => {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    }

    CascaderChange = (value, selectedOptions) => {
        if (value.length > 0) {
            this.setState({
                proDetailType: selectedOptions[2].value,
                proDetailName: selectedOptions[2].label,
                cascaderValue: value,
                addSearchObj: {...this.state.addSearchObj, p: 1}
            });
        } else {
            this.setState({proDetailType: "", proDetailName: "", cascaderValue: []});
        }
    }

    refreshList = () => {
        this.setState({
            usable: true,
        });
        var postCount = 0;
        var finishCount = 0;
        var submitRows = this.state.submitRows;
        submitRows.forEach(() => {
            postCount++;
        });
        submitRows.forEach((row, index) => {

            var postList = {
                channelCode: this.state.orderData.channelCode,
                customerId: parseInt(this.state.orderData.thirdId),
                purchaseId: this.state.detailData.id,
                pickProAddress: this.state.submitRows[index].pickProAddress,
                pickProAddressId: this.state.submitRows[index].delvId,
                proId: this.state.submitRows[index].productId,
                count: this.state.submitRows[index].count || 0,
                receiveAddressId: this.state.receiveAddressId
            };
            getDongList(postList).then(res => {
                if (res.code == 200 && res.data) {
                    finishCount++;
                    if (postCount == finishCount) {
                        this.setState({
                            usable: false,
                        });
                    }
                    var day = this.state.day;
                    var date = this.state.date;
                    var xiaFuJia = this.state.xiaFuJia;
                    var weiFaYunCount = this.state.weiFaYunCount;
                    var onhand = this.state.onhand;
                    var productionCycle = this.state.productionCycle;
                    var defDeliverDay = this.state.defDeliverDay;
                    var productName = this.state.productName;
                    var cadreRepertory = this.state.cadreRepertory;
                    day[index] = res.data.day;
                    date[index] = res.data.date;
                    xiaFuJia[index] = res.data.xiaFuJia;
                    weiFaYunCount[index] = res.data.weiFaYunCount;
                    onhand[index] = res.data.onhand;
                    productionCycle[index] = res.data.productionCycle;
                    defDeliverDay[index] = res.data.defDeliverDay;
                    productName[index] = res.data.productName;
                    cadreRepertory[index] = res.data.cadreRepertory;
                    submitRows[index].xiaFuJia = res.data.xiaFuJia;
                    submitRows[index].onhand = res.data.onhand;
                    submitRows[index].cadreRepertory = res.data.cadreRepertory;
                    submitRows[index].weiFaYunCount = res.data.weiFaYunCount;
                    submitRows[index].productionCycle = res.data.productionCycle;
                    submitRows[index].day = res.data.day;
                    submitRows[index].date = res.data.date;
                    submitRows[index].showPrice = res.data.listPrice;
                    this.setState({
                        day: day,
                        date: date,
                        xiaFuJia: xiaFuJia,
                        onhand: onhand,
                        weiFaYunCount: weiFaYunCount,
                        productionCycle: productionCycle,
                        defDeliverDay: defDeliverDay,
                        productName: productName,
                        cadreRepertory: cadreRepertory,
                        submitRows: submitRows
                    }, () => {
                        this.price();
                    })
                } else {
                    console.log(res);
                }
            })
        })
    }

    handleOk6 = () => {
        if (this.state.quickString.length == 0) {
            this.setState({quickVisible: false, quickLoading: false, quickString: ''});
            return;
        }
        var rowcount = 0;
        var finshcount = 0;
        this.setState({quickLoading: true, quickResult: []});
        this.state.quickString.split(/[\n]/).forEach(item => {
            if (item.trim().length > 0) {
                rowcount++;
            }
        });
        this.state.quickString.split(/[\n]/).forEach(item => {
            if (item.trim().length > 0) {
                var searchItem;
                var count = null;
                if (item.trim().indexOf(",") > 0) {
                    searchItem = item.trim().substr(0, item.trim().indexOf(","));
                    var re = /^[0-9]+$/g;
                    if (re.test(item.trim().substr(item.trim().indexOf(",") + 1))) {
                        count = item.trim().substr(item.trim().indexOf(",") + 1);
                    }
                } else if (item.trim().indexOf(' ') > 0) {
                    searchItem = item.trim().substr(0, item.trim().indexOf(' '));
                    var re = /^[0-9]+$/g;
                    if (re.test(item.trim().substr(item.trim().indexOf(' ') + 1))) {
                        count = item.trim().substr(item.trim().indexOf(' ') + 1);
                    }
                } else if (item.trim().indexOf('\t') > 0) {
                    searchItem = item.trim().substr(0, item.trim().indexOf('\t'));
                    var re = /^[0-9]+$/g;
                    if (re.test(item.trim().substr(item.trim().indexOf('\t') + 1))) {
                        count = item.trim().substr(item.trim().indexOf('\t') + 1);
                    }
                } else {
                    searchItem = item.trim();
                }
                getPro({
                    channelCode: this.state.orderData.channelCode,
                    customerId: this.state.orderData.thirdId,
                    name: searchItem,
                    stockType: this.state.stockType,
                    p: 1,
                    s: 1
                }).then(result => {
                    finshcount++;
                    if (result.status && result.code == 200) {
                        if (result.total > 0) {
                            if (result.data[0].itemManagerFlag == 'Y' && result.data[0].orderManagerFlag == 'Y') {
                                result.data[0].count = count;
                                //this.addSave(result.data[0], null, null);
                                const quickResult = this.state.quickResult;
                                quickResult.push(result.data[0]);
                            }
                        }
                    } else {
                        message.error(result.message);
                        this.setState({quickLoading: false});
                    }
                    if (rowcount == finshcount) {
                        this.state.quickString.split(/[\n]/).forEach(item => {
                            if (item.trim().length > 0) {
                                const quickResult = this.state.quickResult;
                                quickResult.forEach(item2 => {
                                    var searchItem;
                                    if (item.trim().indexOf(',') > 0) {
                                        searchItem = item.trim().substr(0, item.trim().indexOf(','));
                                    } else if (item.trim().indexOf(' ') > 0) {
                                        searchItem = item.trim().substr(0, item.trim().indexOf(' '));
                                    } else if (item.trim().indexOf('\t') > 0) {
                                        searchItem = item.trim().substr(0, item.trim().indexOf('\t'));
                                    } else {
                                        searchItem = item.trim();
                                    }
                                    if (item2.itemNum == searchItem) {
                                        this.addSave(item2, null, null);
                                    }
                                })
                            }
                        });
                        this.refreshList();
                        this.setState({quickVisible: false, quickLoading: false, quickString: '', quickResult: []});
                    }
                })
            }
        });
    }

    /*智能录入弹窗*/
    quickHandler = (event) => {
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            return
        }
        if (!this.state.orgId || this.state.orgId == '') {
            openNotice('warning', '请先选择提货地点');
            return
        }
        this.setState({quickVisible: true});
    }

    /*下载模板*/
    downloadChange() {
        downLoadTemplate(5);
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    }

    /*返回*/
    goBack() {
        // hashHistory.goBack();
        this.goView('order');
    }

    deleteHandler = () => {
        const self = this;
        var selectedRowKeys = this.state.selectedRowKeysOutside;
        if (this.state.selectedRowKeysOutside == '') {
            openNotice('warning', '请确认删除的商品');
            return
        }
        const delKeys = new RegExp(selectedRowKeys.join('|'));
        self.setState({
            ...self.state,
            selectedRowKeys: [],
            // submitRows: self.state.submitRows.filter(x =>  !delKeys.test(x.id)),
            submitRows: self.state.submitRows.filter(x => selectedRowKeys.indexOf(x.id) === -1),
        }, () => {
            self.price();
        })
        for (let i = 0; i < selectedRowKeys.length; i++) {
            var day = self.state.day;
            var date = self.state.date;
            var priceRate = self.state.priceRate;
            var xiaFuJia = self.state.xiaFuJia;
            var jcxf = self.state.jcxf;
            var weiFaYunCount = self.state.weiFaYunCount;
            var onhand = self.state.onhand;
            var productionCycle = self.state.productionCycle;
            var defDeliverDay = self.state.defDeliverDay;
            var productName = self.state.productName;
            var cadreRepertory = self.state.cadreRepertory;
            day.splice([selectedRowKeys[i] - 1], 1);
            cadreRepertory.splice([selectedRowKeys[i] - 1], 1);
            date.splice([selectedRowKeys[i] - 1], 1);
            xiaFuJia.splice([selectedRowKeys[i] - 1], 1);
            jcxf.splice([selectedRowKeys[i] - 1], 1);
            weiFaYunCount.splice([selectedRowKeys[i] - 1], 1);
            priceRate.splice([selectedRowKeys[i] - 1], 1);
            onhand.splice([selectedRowKeys[i] - 1], 1);
            productionCycle.splice([selectedRowKeys[i] - 1], 1);
            defDeliverDay.splice([selectedRowKeys[i] - 1], 1);
            productName.splice([selectedRowKeys[i] - 1], 1);
            self.setState({
                day: day,
                date: date,
                xiaFuJia: xiaFuJia,
                jcxf: jcxf,
                weiFaYunCount: weiFaYunCount,
                priceRate: priceRate,
                cadreRepertory: cadreRepertory,
                onhand: onhand,
                productionCycle: productionCycle,
                defDeliverDay: defDeliverDay,
                productName: productName,
            })
        }
    }
    /*选择外层列表*/
    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeysOutside: selectedRowKeys});
    }
    /*外层翻页*/
    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            this.initData();
        });
    }
    /*选择物料弹窗*/
    searchHandler = (event) => {
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            return
        }
        this.setState({visible: true});
        // this.getAddArray();
    }
    openModal = (record, index, event) => {
        // console.log(record);
        // console.log(index);
        // console.log(event);
        var getList = this.state.submitRows[index].orderProductPartList || [];
        var x = this.state.submitRows[index].productName;
        this.setState({dataSource2: getList, dataSource3: index, productName2: x});
        this.setState({modalVisible: true});
    }
    /*选择物料列表*/
    onSelectChange = (selectedRowKeys, selectedRows) => {
        var add = [];
        for (var i = 0; i < selectedRows.length; i++) {
            add = [...selectedRows];
            // add[i].itemNum= selectedRows[i].itemNum;
            // add[i].productionCycle= selectedRows[i].productionCycle;
            // add[i].pickProAddress= this.state.tiAddress2;
            // add[i].proLine= selectedRows[i].proLine;
            // add[i].productName= selectedRows[i].name;
            // add[i].productId= selectedRows[i].id;
            // add[i].showPrice= selectedRows[i].showPrice;
            // // count: selectedRows[i].viewCount,
            // add[i].remark= selectedRows[i].remark;
            // add[i].stockType= selectedRows[i].stockType;
            // add[i].unit= selectedRows[i].unit;
            // add[i].packageQuantity= selectedRows[i].packageQuantity;
            // add[i].minPackageQuantity= selectedRows[i].minPackageQuantity;
            // minPackageQuantity: selectedRows[0].maxPackageQuantity,
            add[i].pickProAddress = this.state.tiAddress2;
            add[i].productName = selectedRows[i].name;
            add[i].productId = selectedRows[i].id;
        }
        this.setState({
            selectedRowKeys: selectedRowKeys,
            // add: {
            // 	...this.state.add,
            // 	itemNum: selectedRows[0].itemNum,
            // 	productionCycle: selectedRows[0].productionCycle,
            // 	pickProAddress: this.state.tiAddress2,
            // 	proLine: selectedRows[0].proLine,
            // 	productName: selectedRows[0].name,
            // 	productId: selectedRows[0].id,
            // 	showPrice: selectedRows[0].showPrice,
            // 	// count: selectedRows[0].viewCount,
            // 	remark: selectedRows[0].remark,
            // 	stockType: selectedRows[0].stockType,
            // 	unit: selectedRows[0].unit,
            // 	packageQuantity: selectedRows[0].packageQuantity,
            // 	minPackageQuantity: selectedRows[0].minPackageQuantity,
            // 	// minPackageQuantity: selectedRows[0].maxPackageQuantity,
            // }
            add: add
        })
        // this.setState({
        // 	selectedRowKeys: selectedRowKeys,
        // 	add: {
        // 		...this.state.add,
        // 		itemNum: selectedRows[0].itemNum,
        // 		productionCycle: selectedRows[0].productionCycle,
        // 		pickProAddress: this.state.tiAddress2,
        // 		proLine: selectedRows[0].proLine,
        // 		productName: selectedRows[0].name,
        // 		productId: selectedRows[0].id,
        // 		showPrice: selectedRows[0].showPrice,
        // 		// count: selectedRows[0].viewCount,
        // 		remark: selectedRows[0].remark,
        // 		stockType: selectedRows[0].stockType,
        // 		unit: selectedRows[0].unit,
        // 		packageQuantity: selectedRows[0].packageQuantity,
        // 		minPackageQuantity: selectedRows[0].minPackageQuantity,
        // 		// minPackageQuantity: selectedRows[0].maxPackageQuantity,
        // 	}
        // })
    }
    onSelectRadio = (record, selected, selectedRows) => {
        this.setState({
            pId: record.id,
            pListId: record.priceListId
        })
    }
    /*选择物料列表*/
    onSelectChange2 = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRowKeys2: selectedRowKeys,
        })
    }
    onSelectRadio2 = (record, selected, selectedRows) => {
        // console.log(record.orgName);
        // console.log(record.orgId);
        // console.log(selectedRows);
        this.setState({
            orgId: record.orgId,
            lineId: record.lineId,
            orgName: record.orgName,
            province1: record.province,
            gatherCity: record.province,
        });
    }
    /*选择物料列表*/
    onSelectChange3 = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRowKeys3: selectedRowKeys,
        })
    }

    onSelectRadio3 = (record, selected, selectedRows) => {
        // console.log(record);
        // console.log(selectedRows);
        this.setState({
            subsidiaryId: record.lineId,
            subsidiaryName: record.name,
        })
    }

    guiShuChange1 = (event) => {
        this.setState({
            specCode: event.target.value
        });
    };

    guiShuChange2 = (event) => {
        this.setState({
            projectName: event.target.value
        });
    };

    guiShuChange3 = (event) => {
        this.setState({
            userName: event.target.value
        });
    };

    /*选择物料列表翻页*/
    addPageChange = (page, pageSize) => {
        this.setState({addSearchObj: {...this.state.addSearchObj, s: pageSize, p: page}}, function () {
            this.getAddArray();
        });
    }
    addPageChange2 = (page, pageSize) => {
        this.setState({addSearchObj2: {...this.state.addSearchObj2, s: pageSize, p: page}}, function () {
            this.getAddArray2();
        });
    }
    addPageChange3 = (page, pageSize) => {
        this.setState({addSearchObj3: {...this.state.addSearchObj3, s: pageSize, p: page}}, function () {
            this.getAddArray3();
        });
    }

    addPageChange4 = (page, pageSize) => {
        this.setState({addRows4: []});
        this.setState({addSearchObj4: {...this.state.addSearchObj4, s: pageSize, p: page}}, function () {

            this.getAddArray4();
        });
    };

    addPageChange5 = (page, pageSize) => {
        this.setState({addRows5: []});
        this.setState({addSearchObj5: {...this.state.addSearchObj5, s: pageSize, p: page}}, function () {
            this.getAddArray5();
        });
    };

    /*选择物料-物料编码搜索*/
    codeChange = (event) => {
        this.setState({
            code: event.target.value
        });
    }
    /*选择物料-物料名称搜索*/
    nameChange = (event) => {
        this.setState({
            name: event.target.value
        });
    }
    /*选择物料-物料名称搜索*/
    provinceChange = (event) => {
        this.setState({
            province: event.target.value
        });
    }

    openAdd = (proCode) => {
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            return
        }
        this.setState({visible: true, name: proCode}, () => {
            this.getAddArray()
        });
    }
    /*选择物料-物料名称搜索*/
    guiShuChange = (event) => {
        this.setState({
            guiShu: event.target.value
        });
    }

    tsChange = (e) => {
        this.setState({
            stockType: e.target.checked ? "退市" : "",
            ts_checked: e.target.checked,
            addSearchObj: {...this.state.addSearchObj, p: 1}
        });
    }
    lsChange = (e) => {
        this.setState({
            ls_checked: e.target.checked,
            addSearchObj: {...this.state.addSearchObj, p: 1}
        });
    }

    //物料查询界面库存搜索
    stockChange = (value) => {
        switch (value) {
            case '0':
                this.setState({
                    stockType: '库存',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '1':
                this.setState({
                    stockType: '非库存',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '2':
                this.setState({
                    stockType: '定制',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '3':
                this.setState({
                    stockType: '专属定制',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '4':
                this.setState({
                    stockType: '退市',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            default :
                this.setState({
                    stockType: '',
                    ts_disabled: false,
                    ts_checked: false,
                });
                break;
        }
    }
    /*选择物料列表数据(点击搜索)*/
    getAddArray = () => {
        if (this.state.name == '') {
            openNotice('warning', '请输入物料名称或编码');
            return
        }
        if (this.state.name != this.state.lastsearch) {
            this.state.addSearchObj.p = 1;
            this.state.lastsearch = this.state.name;
        }
        this.setState({loading: true});
        getPro({
            channelCode: this.state.orderData.channelCode,
            customerId: this.state.orderData.thirdId,
            keyword: this.state.code,
            name: this.state.name,
            stockType: this.state.stockType,
            proDetailType: this.state.proDetailType,
            proDetailName: this.state.proDetailName,
            delisting: this.state.ts_checked,
            historyOpen: this.state.ls_checked,
            businessLines: this.state.businessLines,
            p: this.state.addSearchObj.p,
            s: this.state.addSearchObj.s
        }).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    addRows: result.data,
                    addTotal: result.total,
                    loading: false
                });
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })
    }

    keypress = (e) => {
        if (e.which == 13) {
            this.getAddArray();
        }
    }
    /*选择省市列表数据(点击搜索)*/
    getAddArray2 = () => {
        getPro2({
            // code: this.state.code,
            orgId: this.state.subsidiaryOrgId ? this.state.subsidiaryOrgId : (this.state.submitRows.length > 0 ? (this.state.submitRows[0].reserveLid ? this.state.submitRows[0].delvId : null) : null),
            province: this.state.province,
            p: this.state.addSearchObj2.p,
            s: this.state.addSearchObj2.s,
            purchaseId: this.state.purchaseId
        }).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    addRows2: result.data,
                    addTotal2: result.total,
                });
            } else {
                message.error(result.message);
            }
        })

    }
    getAddArray3 = () => {
        getPro3({
            cusId: this.state.orderData.thirdId,
            name: this.state.guiShu,
            p: this.state.addSearchObj3.p,
            s: this.state.addSearchObj3.s
        }).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    addRows3: result.data,
                    addTotal3: result.total,
                }, () => {
                    if (result.data.length == 1) {
                        this.setState({
                            subsidiaryId: result.data[0].lineId,
                            subsidiaryName: result.data[0].name,
                            subsidiaryOrgId: result.data[0].organizationId
                        })
                    }
                });
            } else {
                message.error(result.message);
            }
        })

    }

    //查询特价信息
    getAddArray4 = () => {
        /*if (!this.state.businessChannel) {
            openNotice('warning', '请先确定业务归属渠道');
            return
        }*/
        //李 新增
        //分页查询在只有将页码赋值到第一页才能在当前页查询不同页码内的数据
        if (this.state.specCode != this.state.lastsearch) {
            this.state.addSearchObj4.p = 1;
            this.state.lastsearch = this.state.specCode;
        }
        //存在问题（项目名称）
        /*if (this.state.projectName != this.state.lastsearch) {
            this.state.addSearchObj4.p = 1;
            this.state.lastsearch = this.state.projectName;
        }*/

        getPro4({
            projectName: this.state.projectName,
            specCode: this.state.specCode,
            cusCode: this.state.detailData.cusCode,
            buyCompanyId: this.state.purchaseId,
            userName: this.state.userName,
            //channelCode: this.state.businessChannel,
            // cusCode:131527,
            // buyCompanyId:56821,
            // channelCode:'DL',
            p: this.state.addSearchObj4.p,
            s: this.state.addSearchObj4.s
        }).then(result => {
            if (result.status && result.code == 200) {
                // debugger
                // console.log(result)
                var data = result.data;
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].id = i + 1;
                }
                this.setState({
                    addRows4: data,
                    addTotal4: result.total,
                    // tiAddress: result,
                });
            } else {
                message.error(result.message);
            }
        })

    };

    onSelectChange4 = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRowKeys4: selectedRowKeys,
        })
    };

    getAddArray5 = () => {
        //李 新增
        //分页查询在只有将页码赋值到第一页才能在当前页查询不同页码内的数据
        if (this.state.specCode1 != this.state.lastsearch) {
            this.state.addSearchObj5.p = 1;
            this.state.lastsearch = this.state.specCode1;
        }
        getPro5({
            specCode: this.state.specCode1,
            p: this.state.addSearchObj5.p,
            s: this.state.addSearchObj5.s
        }).then(result => {
            if (result.status && result.code == 200) {
                // debugger
                // console.log(result)
                var data = result.data;
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].id = i + 1;
                }
                this.setState({
                    addRows5: data,
                    addTotal5: result.total,
                    // tiAddress: result,
                });
            } else {
                message.error(result.message);
            }
        })

    };

    /**/
    addSaveHandler2 = () => {
        const self = this;
        if (self.state.selectedRowKeys2.length === 0) {
            openNotice('warning', '请选择至少一条省市列表数据');
            return;
        }
        /*确认*/
        self.doSave2();
        /*清空信息*/
        self.doClear2();
        var submitRows = self.state.submitRows;
        var postCount = 0;
        var finishCount = 0;
        self.setState({
            usable: true,
        });
        for (let record = 0; record < submitRows.length; record++) {
            submitRows[record].pickProAddress = self.state.orgName;
            submitRows[record].delvId = self.state.orgId;
            var postList = {
                channelCode: self.state.orderData.channelCode,
                customerId: parseInt(self.state.orderData.thirdId),
                purchaseId: self.state.detailData.id,
                pickProAddress: self.state.orgName || '',
                pickProAddressId: self.state.orgId || '',
                proId: self.state.submitRows[record].productId,
                count: self.state.submitRows[record].count || 0,
                // this.state.submitRows[record.id-1].count
                receiveAddressId: self.state.receiveAddressId,
            };
            postCount++;
            getDongList(postList).then(res => {
                if (res.code == 200 && res.data) {
                    finishCount++;
                    if (postCount == finishCount) {
                        self.setState({
                            usable: false,
                        });
                    }
                    // console.log(res);
                    var day = self.state.day;
                    var productionCycle = self.state.productionCycle;
                    // console.log('index'+index);
                    // console.log('key'+key)
                    // console.log('record'+record)
                    var date = self.state.date;
                    var xiaFuJia = self.state.xiaFuJia;
                    var jcxf = self.state.jcxf;
                    var weiFaYunCount = self.state.weiFaYunCount;
                    var priceRate = self.state.priceRate;
                    var onhand = self.state.onhand;
                    var cadreRepertory = self.state.cadreRepertory;
                    var defDeliverDay = self.state.defDeliverDay;
                    var productName = self.state.productName;
                    // console.log(res.data.day)
                    day[record] = res.data.day;
                    productionCycle[record] = res.data.productionCycle;
                    date[record] = res.data.date;
                    xiaFuJia[record] = res.data.xiaFuJia;
                    jcxf[record] = res.data.jcxf;
                    weiFaYunCount[record] = res.data.weiFaYunCount;
                    priceRate[record] = res.data.priceRate;
                    onhand[record] = res.data.onhand;
                    cadreRepertory[record] = res.data.cadreRepertory;
                    defDeliverDay[record] = res.data.defDeliverDay;
                    productName[record] = res.data.productName;
                    submitRows[record].xiaFuJia = res.data.xiaFuJia;
                    submitRows[record].onhand = res.data.onhand;
                    submitRows[record].cadreRepertory = res.data.cadreRepertory;
                    submitRows[record].weiFaYunCount = res.data.weiFaYunCount;
                    submitRows[record].productionCycle = res.data.productionCycle;
                    submitRows[record].day = res.data.day;
                    submitRows[record].date = res.data.date;
                    submitRows[record].showPrice = res.data.listPrice;
                    self.setState({
                        day: day,
                        productionCycle: productionCycle,
                        date: date,
                        xiaFuJia: xiaFuJia,
                        jcxf: jcxf,
                        weiFaYunCount: weiFaYunCount,
                        priceRate: priceRate,
                        onhand: onhand,
                        cadreRepertory: cadreRepertory,
                        defDeliverDay: defDeliverDay,
                        productName: productName,
                        submitRows: submitRows
                    }, () => {
                        // console.log(day)
                        self.price();
                    })
                } else {
                    console.log(res);
                }
            })

        }
        self.setState({visible2: false});
    }

    addSaveHandler4 = () => {
        const self = this;
        if (this.state.selectedRowKeys4.length === 0) {
            openNotice('warning', '请选择至少一条列表数据');
            return;
        }
        /*确认*/
        //this.doSave4();
        /*清空信息*/
        //this.doClear4();
        this.setState({
            teJiaShow: true,
        });
        this.setState({visible4: false});
    }

    /*拉动渠道选中*/
    pullChannelChange = (value) => {
        this.setState({
            pullChannel: value,
        });
    }

    addSaveHandler3 = () => {
        if (this.state.selectedRowKeys3.length === 0) {
            openNotice('warning', '请选择至少一条归属子库存列表数据');
            return;
        }
        /*确认*/
        this.doSave3();
        /*清空信息*/
        this.doClear3();
        this.setState({visible3: false});
    }
    /*添加行*/
    addSave = (record, index, value) => {
        // debugger
        // console.log(record)
        // console.log(this.state.submitRows.productId)
        const self = this;
        var x = 0;
        for (var i = 0; i < this.state.submitRows.length; i++) {
            if (this.state.submitRows[i].productId == record.id || this.state.submitRows[i].productId == record.productId) {
                x = 1;
            }
        }
        if (x == 1) {
            openNotice('warning', '商品已添加', null, 1);
            return
        }
        var submitRows = [...this.state.submitRows];
        var addSave = {...record};
        addSave.productId = addSave.id;


        giveTeJia({
            customerId: parseInt(self.state.orderData.thirdId),
            proId: record.id,
            purchaseId: self.state.detailData.id,
            channelCode: self.state.channelCode,
            flowCode: self.state.guiShu1,
        }).then(result => {
            if (result.data.terminalPriceRate == '' && result.data.terminalUnitPrice == '') {
                addSave.specialFlag = 0;
            } else {
                addSave.specialFlag = 1;
            }
            addSave.offerLineId = result.data.offerLineId;
        })

        addSave.id = window.myTemp++;
        addSave.productName = addSave.name;
        if (addSave.count == null) {
            addSave.count = 0;
        }
        if (self.state.orgName) {
            addSave.delvId = self.state.orgId;
            addSave.pickProAddressId = self.state.orgId;
            addSave.pickProAddress = self.state.orgName;
        }
        submitRows.push(addSave);
        self.setState({submitRows: submitRows});
        openNotice('success', '商品添加成功', null, 1);
    }
    /*点击确定保存*/
    addSaveHandler = (value) => {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择至少一条物料列表数据');
            return;
        }
        var x = 0;
        for (var i = 0; i < this.state.submitRows.length; i++) {
            for (var j = 0; j < this.state.selectedRowKeys.length; j++) {
                if (this.state.submitRows[i].productId == this.state.selectedRowKeys[j]) {
                    x = 1;
                }
            }
        }
        // if (x == 1) {
        // 	openNotice('warning', '商品已添加');
        // 	return
        // }
        /*确认*/
        this.doSave(value);
        /*清空信息*/
        this.doClear();
        if (value != 1) {
            this.setState({visible: false});
            this.setState({modalVisible: false});
        }
    }
    // doSave = (value) => {
    // 	this.state.add.id = window.myTemp++;
    // 	this.setState({submitRows: [...this.state.submitRows, this.state.add]});
    // 	if ( value != 1) {
    // 		this.setState({visible: false});
    // 		this.setState({modalVisible: false});
    // 	}
    // }
    doSave = (value) => {
        const self = this;
        var submitRows = [...this.state.submitRows];
        for (let i = 0; i < self.state.add.length; i++) {
            self.state.add[i].id = window.myTemp++;
            self.state.add[i].count = 0; //TODO
            if (self.state.orgName) {
                self.state.add[i].delvId = self.state.orgId;
                self.state.add[i].pickProAddressId = self.state.orgId;
                self.state.add[i].pickProAddress = self.state.orgName;
            }
            submitRows.push(self.state.add[i]);
        }
        self.setState({submitRows: submitRows});
        if (value != 1) {
            self.setState({visible: false});
            self.setState({modalVisible: false});
        }
    }
    doSave2 = () => {
        this.setState({visible2: false});
    }
    doSave3 = () => {
        this.setState({visible3: false});
    }
    doSave4 = () => {
        this.setState({visible4: false});
    }
    doClear = () => {
        this.setState({
            name: '',
            code: '',
            add: {
                ...this.state.add,
            },
            selectedRowKeys: [],
        });
    }
    doClear2 = () => {
        this.setState({
            province: '',
            selectedRowKeys2: [],
        });
    }
    doClear3 = () => {
        this.setState({
            guiShu: '',
            selectedRowKeys3: [],
        });
    }
    doClear4 = () => {
        this.setState({
            guiShu1: '',
            selectedRowKeys4: [],
        });
    };
    /*点击保存提交数据*/
    createHandler = (value) => {
        let self = this;
        this.setState({confirmLoading: true});
        if (this.state.vipOrderFlag == 'N') {
            openNotice('warning', '该单位没有合作伙伴订单的开单权限');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        if ((this.state.orderData.thirdId == 3139 || this.state.orderData.thirdId == 352773) && this.state.subsidiaryId == null) {
            openNotice('warning', '请选择归属子公司');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        if (!this.state.businessChannel || this.state.businessChannel == '') {
            openNotice('warning', '请选择业务归属渠道');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        if (this.state.projectMessage == '') {
            openNotice('warning', '请选择项目信息');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        if (!this.state.orgName || this.state.orgName == '') {
            openNotice('warning', '请选择收货省市');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        if (!this.state.partnerOrderType || this.state.partnerOrderType == '') {
            openNotice('warning', '请选择订单模式');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        self.setState({usable: true});
        var userData = this.state.userData;
        var orderData = this.state.orderData;
        var detailData = this.state.detailData;
        var createObj = {};
        createObj = {
            "amount": this.state.allPrice,
            "buyCompany": orderData.PurchaseUnit,
            "channel": orderData.channel,
            "lineId": this.state.lineId,
            "subsidiaryId": this.state.subsidiaryId,
            "partnerOrderType": this.state.partnerOrderType,
            "businessChannel": this.state.businessChannel,
            "pullChannel": this.state.pullChannel,
            "pullmanName": this.state.pullmanName,
            "deliveryShowprice": this.state.deliveryShowprice,
            // "closeHomologous": "结算对应号(项目订单)",
            //  "completeFactory": "成套厂(项目订单) ",
            "contacts": this.state.recipientName,
            //  "contractOrderName": "合同/订单名称(项目订单) ",
            // "createdBy": userData.id, (后端说不传)
            "createdDate": detailData.createdDate,
            //  "creditExtensionMode": "授信方式(项目订单) ",
            "cusId": orderData.thirdId,
            "customerCode": detailData.cusCode,
            "customerName": detailData.cusName,
            "customerOrderCode": this.state.customerOrderCode,
            "customerProjectMsg": this.state.customerProjectMsg,
            "discountRate": this.state.defDiscount,
            //  "gatherAddress": "收货地址(项目订单) ",
            "gatherCity": this.state.gatherCity,
            //  "gatherOrderAddress": "收单地址(项目订单) ",
            "gatherRealityAddress": this.state.gatherRealityAddress || '',
            "guaranteeQuality": 0,
            "orderBackMsg": '',
            "orderType": "3", /*1常规订单2项目订单3合作伙伴订单*/
            "phone": this.state.mobile,
            //  "projectAddMsg": "终端附加信息(项目订单)",
            //  "projectCooperation": "项目合作(项目订单) ",
            "projectMessage": this.state.projectMessage || '',
            "projectName": detailData.name,
            "remainingSum": orderData.sxeAmount,
            "remark": this.state.remark,
            "removeFlag": 0,
            "salesmanName": this.state.seller,
            //  "sellType": "销售方(项目订单) ",
            // "specialOfferCode": this.state.subsidiaryName,
            "specialOfferCode": this.state.specCode1,
            "submitType": 1, /*提交1保存0*/
            "userId": userData.id,
            "buyCompanyId": this.state.detailData.id,
            "gatherAddressId": this.state.receiveAddressId,
            "creditExtensionId": this.state.detailData.id,
            "orgId": 82,
            "gatherCityId": this.state.lineId,//收货省市(合作伙伴订单)
            "projectId": this.state.projectId,
            "province1": this.state.province1,
            "isTg": "是否天正订单",
            // "businessChannel":"业务渠道归属",
            //  "proLine":"产品线(后端说不传)",
            //  "delvId":"提货地点ID(后端说不传)",
            "discountPoolSum": orderData.discountAmount,
            "realityAmount": this.state.realyPrice,
            "isSecond": 0,
            "channelCode": orderData.channelCode,
            "cusUserId": detailData.cusUserId || '',
            "affiliationChannel": this.state.affiliationChannel,
            "subsidiaryName": this.state.subsidiaryName,
            "orderSource": orderData.orderSource,
            "getProCode": this.state.getProCode || '',
            "wholeDelivery": this.state.wholeDelivery,
            "sourceNo": this.state.sourceNo
        }
        if (!this.state.getProCode) {
            delete createObj.getProCode;
        }
        if (value == 2) {
            createObj.submitType = 2
        }
        if (self.props.params.id == 6) {
            createObj.headerId = self.state.headerId;
            createObj.reserveHid = self.state.reserveHid;
        }
        if (this.props.params.id == 9) {
            createObj.id = this.props.params.orderId;
            if (this.props.params.type && this.props.params.type == '再来一单') {
                createObj.id = '';
                delete createObj.getProCode;
            }
        }
        var obj2 = JSON.parse(JSON.stringify(this.state.submitRows));
        for (var i = 0; i < this.state.submitRows.length; i++) {
            obj2[i].logisticsRepertory = this.state.onhand[i]; //参考可用量 //分物流库存
            obj2[i].cadreRepertory = this.state.cadreRepertory[i]; //参考可用量 //分物流库存
            obj2[i].price = this.state.xiaFuJia[i]; //下浮价
            obj2[i].jcxf = this.state.jcxf[i]; //下浮价
            obj2[i].weiFaYunCount = this.state.weiFaYunCount[i];
            obj2[i].priceRate = this.state.priceRate[i]; //下浮价
            obj2[i].logisticsCycle = this.state.day[i];
            obj2[i].productionCycle = this.state.productionCycle[i];
            obj2[i].referenceArrivalDate = this.state.date[i];
            obj2[i].productCode = this.state.submitRows[i].itemNum;
            obj2[i].originalPrice = this.state.submitRows[i].showPrice;
            obj2[i].delvId = this.state.orgId;
            obj2[i].pickProAddress = this.state.orgName;
            obj2[i].customerOrderLine = this.state.submitRows[i].customerOrderLine;
            obj2[i].offerLineId = this.state.submitRows[i].offerLineId;
            obj2[i].maxAcceptQty = this.state.submitRows[i].maxAcceptQty;
            if (obj2[i].originalPrice == "" || obj2[i].originalPrice == undefined) {
                openNotice('error', '物料编码：' + obj2[i].productCode + ' 牌价为空，请联系生产计划部，检查物料是否分配到' + obj2[i].pickProAddress + '，或面价是否正常。', '');
                this.setState({usable: false});
                return;
            }
            switch (this.state.submitRows[i].proLine) {
                case  '元器件':
                    obj2[i].proLine = '01';
                    break;
                case  '电工':
                    obj2[i].proLine = '02';
                    break;
                case  '电表':
                    obj2[i].proLine = '03';
                    break;
                case  '变频器':
                    obj2[i].proLine = '04';
                    break;
                case  '天e':
                    obj2[i].proLine = '05';
                    break;
                case  'TG精品':
                    obj2[i].proLine = '06';
                    break;
            }
            if (this.props.params.id == 9) {
                obj2[i].cadreRepertory = this.state.cadreRepertory[i];
                obj2[i].priceRate = this.state.priceRate[i];
            }
            obj2[i].createdDate = detailData.createdDate;
            obj2[i].createdBy = detailData.createdBy;
            obj2[i].removeFlag = 0;
            if (this.props.params.id == 9) {
                obj2[i].createdBy = this.state.createdBy;
                // obj2[i].delvId = this.state.delvId;
            }
            delete obj2[i].id;
            delete obj2[i].showPrice;
            delete obj2[i].itemNum;
            if ((self.state.submitRows[i].weiFaYunCount && self.state.submitRows[i].weiFaYunCount != 0) || (self.state.weiFaYunCount[i] && self.state.weiFaYunCount[i] != 0)) {
                // if () {
                var existUnFaYun = 1;
                // }
            }
        }
        createObj.productList = obj2;
        var x = 0;
        if (createObj.productList.length > 0) {
            for (var i = 0; i < createObj.productList.length; i++) {
                if (!createObj.productList[i].count) {
                    x = 1;
                }
            }
        }
        // console.log(createObj);
        if (existUnFaYun == 1) {
            confirm({
                content: '存在未发运数量，是否继续？',
                onOk() {
                    if (createObj.productList.length < 1) {
                        openNotice('error', '请添加商品', '');
                        self.setState({confirmvisible: false, confirmLoading: false});
                        self.setState({usable: false});
                        return
                    } else {
                        if (x == 1) {
                            openNotice('error', '请确认数量', '');
                            self.setState({confirmvisible: false, confirmLoading: false});
                            self.setState({usable: false});
                            return
                        } else {
                            /*if (self.state.giveBackStatus == 4) {
								createObj.headerId = this.state.headerId2;
								giveBefore(createObj).then(result => {
									if (result.status && result.code == 200) {
										openNotice('success', '创建成功', '');
										self.goView('order');
									} else {
										openNotice('error', '创建失败', result.message || '');
										self.setState({usable:false});
										return
									}
								});
							} else {*/
                            create(createObj).then(result => {
                                if (result.status && result.code == 200) {
                                    updateOrderLineAttribute(result.data.sourceNo);
                                    openNotice('success', '创建成功', '');
                                    self.setState({confirmvisible: false, confirmLoading: false});
                                    self.goView('order');
                                } else {
                                    openNotice('error', '创建失败', result.message || '');
                                    self.setState({confirmvisible: false, confirmLoading: false});
                                    self.setState({usable: false});
                                    return
                                }
                            });
                            //	}
                        }
                    }
                },
                onCancel() {
                    self.setState({confirmvisible: false, confirmLoading: false});
                    self.setState({usable: false});
                    return
                },
            });
        } else {
            if (createObj.productList.length < 1) {
                openNotice('error', '请添加商品', '');
                self.setState({confirmvisible: false, confirmLoading: false});
                self.setState({usable: false});
            } else {
                if (x == 1) {
                    openNotice('error', '请确认数量', '');
                    self.setState({confirmvisible: false, confirmLoading: false});
                    self.setState({usable: false});
                } else {
                    if (self.state.giveBackStatus == 4) {
                        createObj.headerId = this.state.headerId2;
                        giveBefore(createObj).then(result => {
                            if (result.status && result.code == 200) {
                                updateOrderLineAttribute(result.data.sourceNo);
                                openNotice('success', '创建成功', '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.goView('order');
                            } else {
                                openNotice('error', '创建失败', result.message || '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.setState({usable: false});
                            }
                        });
                    } else {
                        create(createObj).then(result => {
                            if (result.status && result.code == 200) {
                                updateOrderLineAttribute(result.data.sourceNo);
                                openNotice('success', '创建成功', '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.goView('order');
                            } else {
                                openNotice('error', '创建失败', result.message || '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.setState({usable: false});
                            }
                        });
                    }
                }
            }
        }

    };

    createHandler2 = (value) => {
        var loginData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
        /*console.log(this.state);
        console.log(loginData.loginName);
        console.log(loginData.loginName.includes("139436_") );*/
        if (loginData.loginName.includes("139436_") || loginData.loginName.includes("504639_")) {
            if (this.state.subsidiaryName == null) {
                openNotice('warning', '请选择归属子公司');
                return;
            }
        }
        if (this.state.vipOrderFlag == 'N') {
            openNotice('warning', '该单位没有合作伙伴订单的开单权限');
            return;
        }
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            return;
        }
        if (!this.state.businessChannel || this.state.businessChannel == '') {
            openNotice('warning', '请选择业务归属渠道');
            return;
        }
        if (this.state.projectMessage == '') {
            openNotice('warning', '请选择项目信息');
            return;
        }
        if (!this.state.orgName || this.state.orgName == '') {
            openNotice('warning', '请选择收货省市');
            return;
        }
        if (!this.state.partnerOrderType || this.state.partnerOrderType == '') {
            openNotice('warning', '请选择订单模式');
            return;
        }
        var self = this;
        self.setState({usable: true});
        var userData = this.state.userData;
        var orderData = this.state.orderData;
        var detailData = this.state.detailData;
        var createObj = {};
        createObj = {
            "amount": this.state.allPrice,
            "buyCompany": orderData.PurchaseUnit,
            "channel": orderData.channel,
            "lineId": this.state.lineId,
            "subsidiaryId": this.state.subsidiaryId,
            "partnerOrderType": this.state.partnerOrderType,
            "businessChannel": this.state.businessChannel,
            "pullChannel": this.state.pullChannel,
            "pullmanName": this.state.pullmanName,
            "deliveryShowprice": this.state.deliveryShowprice,
            // "closeHomologous": "结算对应号(项目订单)",
            //  "completeFactory": "成套厂(项目订单) ",
            "contacts": this.state.recipientName,
            //  "contractOrderName": "合同/订单名称(项目订单) ",
            // "createdBy": userData.id, (后端说不传)
            "createdDate": detailData.createdDate,
            //  "creditExtensionMode": "授信方式(项目订单) ",
            "cusId": orderData.thirdId,
            "customerCode": detailData.cusCode,
            "customerName": detailData.cusName,
            "customerOrderCode": this.state.customerOrderCode,
            "customerProjectMsg": this.state.customerProjectMsg,
            "discountRate": this.state.defDiscount,
            //  "gatherAddress": "收货地址(项目订单) ",
            "gatherCity": this.state.gatherCity,
            //  "gatherOrderAddress": "收单地址(项目订单) ",
            "gatherRealityAddress": this.state.gatherRealityAddress || '',
            "guaranteeQuality": 0,
            "orderBackMsg": '',
            "orderType": "3", /*1常规订单2项目订单3合作伙伴订单*/
            "phone": this.state.mobile,

            //  "projectAddMsg": "终端附加信息(项目订单)",
            //  "projectCooperation": "项目合作(项目订单) ",
            "projectMessage": this.state.projectMessage || '',
            "projectName": detailData.name,
            "remainingSum": orderData.sxeAmount,
            "remark": this.state.remark,
            "removeFlag": 0,
            "salesmanName": this.state.seller,
            //  "sellType": "销售方(项目订单) ",
            // "specialOfferCode": this.state.subsidiaryName,
            "specialOfferCode": this.state.specCode1,
            "submitType": 0, /*提交1保存0*/
            "userId": userData.id,
            "buyCompanyId": this.state.detailData.id,
            "gatherAddressId": this.state.receiveAddressId,
            "creditExtensionId": this.state.detailData.id,
            "orgId": 82,
            "gatherCityId": this.state.lineId,//收货省市(合作伙伴订单)
            "projectId": this.state.projectId,
            "isTg": "是否天正订单",
            "province1": this.state.province1,
            // "businessChannel":"业务渠道归属",
            //  "proLine":"产品线(后端说不传)",
            //  "delvId":"提货地点ID(后端说不传)",
            "discountPoolSum": orderData.discountAmount,
            "realityAmount": this.state.realyPrice,
            "isSecond": 0,
            "channelCode": orderData.channelCode,
            "cusUserId": detailData.cusUserId || '',
            "affiliationChannel": this.state.affiliationChannel,
            "subsidiaryName": this.state.subsidiaryName,
            "getProCode": this.state.getProCode || '',
            "orderSource": orderData.orderSource,
            "wholeDelivery": this.state.wholeDelivery,
            "sourceNo": this.state.sourceNo
        }
        if (!this.state.getProCode) {
            delete createObj.getProCode;
        }
        if (self.props.params.id == 6) {
            createObj.headerId = self.state.headerId;
            createObj.reserveHid = self.state.reserveHid;
        }
        if (this.props.params.id == 9) {
            createObj.id = this.props.params.orderId;
            if (this.props.params.type && this.props.params.type == '再来一单') {
                createObj.id = '';
                delete createObj.getProCode;
                delete createObj.orderSource;
            }
        }
        var obj2 = JSON.parse(JSON.stringify(this.state.submitRows));
        for (var i = 0; i < this.state.submitRows.length; i++) {
            obj2[i].availableReferenceQuantity = this.state.onhand[i]; //参考可用量
            obj2[i].price = this.state.xiaFuJia[i]; //下浮价
            obj2[i].jcxf = this.state.jcxf[i]; //下浮价
            obj2[i].weiFaYunCount = this.state.weiFaYunCount[i]; //下浮价
            obj2[i].logisticsCycle = this.state.day[i];
            obj2[i].referenceArrivalDate = this.state.date[i];
            obj2[i].productCode = this.state.submitRows[i].itemNum;
            obj2[i].originalPrice = this.state.submitRows[i].showPrice;
            obj2[i].cadreRepertory = this.state.cadreRepertory[i]; //本部库存
            obj2[i].priceRate = this.state.priceRate[i]; //下浮价
            obj2[i].delvId = this.state.orgId;
            obj2[i].pickProAddress = this.state.orgName;
            obj2[i].customerOrderLine = this.state.submitRows[i].customerOrderLine;
            obj2[i].offerLineId = this.state.submitRows[i].offerLineId;
            obj2[i].maxAcceptQty = this.state.submitRows[i].maxAcceptQty;
            if (obj2[i].originalPrice == "" || obj2[i].originalPrice == undefined) {
                openNotice('error', '物料编码：' + obj2[i].productCode + ' 牌价为空，请联系生产计划部，检查物料是否分配到' + obj2[i].pickProAddress + '，或面价是否正常。', '');
                this.setState({usable: false});
                return;
            }
            switch (this.state.submitRows[i].proLine) {
                case  '元器件':
                    obj2[i].proLine = '01';
                    break;
                case  '电工':
                    obj2[i].proLine = '02';
                    break;
                case  '电表':
                    obj2[i].proLine = '03';
                    break;
                case  '变频器':
                    obj2[i].proLine = '04';
                    break;
                case  '天e':
                    obj2[i].proLine = '05';
                    break;
                case  'TG精品':
                    obj2[i].proLine = '06';
                    break;
            }
            obj2[i].createdDate = detailData.createdDate;
            obj2[i].createdBy = detailData.createdBy;
            obj2[i].removeFlag = 0;
            if (this.props.params.id == 9) {
                obj2[i].createdBy = this.state.createdBy;
                // obj2[i].delvId = this.state.delvId;
            }
            delete obj2[i].id;
            delete obj2[i].showPrice;
            delete obj2[i].itemNum;
            if ((self.state.submitRows[i].weiFaYunCount && self.state.submitRows[i].weiFaYunCount != 0) || (self.state.weiFaYunCount[i] && self.state.weiFaYunCount[i] != 0)) {
                // if () {
                var existUnFaYun = 1;
                // }
            }
        }
        createObj.productList = obj2;
        console.dir(createObj);
        var x = 0;
        if (createObj.productList.length > 0) {
            for (var i = 0; i < createObj.productList.length; i++) {
                if (!createObj.productList[i].count) {
                    x = 1;
                }
            }
        }
        if (existUnFaYun == 1) {
            confirm({
                content: '存在未发运数量，是否继续？',
                onOk() {
                    if (createObj.productList.length < 1) {
                        openNotice('error', '请添加商品', '');
                        self.setState({usable: false});

                    } else {
                        if (x == 1) {
                            openNotice('error', '请确认数量', '');
                            self.setState({usable: false});
                        } else {
                            createForSave(createObj).then(result => {
                                if (result.status && result.code == 200) {
                                    openNotice('success', '保存成功', '');
                                    self.setState({getProCode: result.data.getProCode});
                                    self.setState({sourceNo: result.data.sourceNo});
                                    self.setState({orderSubmit4: 'block'});
                                    self.goView(`order/addPartners1/${9}&${result.data.id}`);
                                    self.setState({usable: false});
                                } else {
                                    openNotice('error', '创建失败', result.message || '');
                                    self.setState({usable: false});
                                }
                            });
                        }
                    }
                },
                onCancel() {
                    self.setState({usable: false});
                    return
                },
            });
        } else {
            if (createObj.productList.length < 1) {
                openNotice('error', '请添加商品', '');
                self.setState({usable: false});
            } else {
                if (x == 1) {
                    openNotice('error', '请确认数量', '');
                    self.setState({usable: false});
                } else {
                    createForSave(createObj).then(result => {
                        if (result.status && result.code == 200) {
                            openNotice('success', '保存成功', '');
                            self.setState({getProCode: result.data.getProCode});
                            self.setState({sourceNo: result.data.sourceNo});
                            self.setState({orderSubmit4: 'block'});
                            self.goView(`order/addPartners1/${9}&${result.data.id}`);
                            self.setState({usable: false});
                        } else {
                            openNotice('error', '创建失败', result.message || '');
                            self.setState({usable: false});
                        }
                    });
                }
            }
        }
    }

    deliveryShowpriceChange = (value) => {
        this.setState({
            deliveryShowprice: value || '',
        });
    };

    wholeDeliveryChange = (value) => {
        this.setState({
            wholeDelivery: value || '',
        });
    };
    /*获取数据*/
    initData = () => {
        var orderListData = this.state.orderListData;
        var orderData = this.state.orderData;
        /*获取详情数据*/
        this.setState({
            loading: true
        })
        const self = this;
        var purchaseId = this.state.purchaseId;
        var thirdId = this.state.orderData.thirdId;
        if (this.state.subsidiaryId == null) {
            this.getAddArray3();
        }
        getDetail(purchaseId, thirdId).then(res => {
            var x = res.data;
            var timestamp = new Date().getTime();
            x.createdDate = timestamp;
            self.setState({
                detailData: x,
                optionAddress: res.data.addressList || '',
                optionTerminal: res.data.terminalList || '',
                vipOrderFlag: res.data.vipOrderFlag || '',
                loading: false
            }, () => {
                if (res.data.addressList.length == 1 && this.props.params.id != 6) {
                    this.setState({
                        gatherRealityAddress2: res.data.addressList[0].id + '',
                        gatherRealityAddress: res.data.addressList[0].detailAddress,
                        recipientName: res.data.addressList[0].recipientName,
                        mobile: res.data.addressList[0].mobile,
                        receiveAddressId: res.data.addressList[0].id,
                        deliveryShowprice: res.data.addressList[0].deliveryShowPrice || 'Y',
                        xinzengShow: false,
                        xinzengShow1: false,
                        loading: false
                    });
                }
            });
        })
    }
    /*实际收货地址选中*/
    addressChange = (value) => {
        const self = this;
        var address = this.state.optionAddress.filter(x => x.id == value)[0];
        var recipientName = address.recipientName;
        var receiveAddressId = address.id;
        var mobile = address.mobile;
        var detailAddress = address.detailAddress;
        var deliveryShowPrice = address.deliveryShowPrice;
        var submitRows = [...self.state.submitRows];
        var postCount = 0;
        var finishCount = 0;
        self.setState({
            usable: true,
        });
        for (let index = 0; index < submitRows.length; index++) {
            var postList = {
                channelCode: self.state.orderData.channelCode,
                customerId: parseInt(self.state.orderData.thirdId),
                purchaseId: self.state.detailData.id,
                pickProAddress: self.state.orgName || '',
                pickProAddressId: self.state.orgId || '',
                proId: self.state.submitRows[index].productId,
                count: self.state.submitRows[index].count || 0,
                // this.state.submitRows[index.id-1].count
                receiveAddressId: receiveAddressId,
            };
            postCount++;
            getDongList(postList).then(res => {
                if (res.code == 200 && res.data) {
                    finishCount++;
                    if (postCount == finishCount) {
                        self.setState({
                            usable: false,
                        });
                    }
                    var day = self.state.day;
                    var productionCycle = self.state.productionCycle;
                    var date = self.state.date;
                    var xiaFuJia = self.state.xiaFuJia;
                    var jcxf = self.state.jcxf;
                    var weiFaYunCount = self.state.weiFaYunCount;
                    var priceRate = self.state.priceRate;
                    var onhand = self.state.onhand;
                    var cadreRepertory = self.state.cadreRepertory;
                    var defDeliverDay = self.state.defDeliverDay;
                    var productName = self.state.productName;
                    // console.log(res.data.day)
                    day[index] = res.data.day;
                    productionCycle[index] = res.data.productionCycle;
                    date[index] = res.data.date;
                    xiaFuJia[index] = res.data.xiaFuJia;
                    jcxf[index] = res.data.jcxf;
                    weiFaYunCount[index] = res.data.weiFaYunCount;
                    priceRate[index] = res.data.priceRate;
                    onhand[index] = res.data.onhand;
                    cadreRepertory[index] = res.data.cadreRepertory;
                    defDeliverDay[index] = res.data.defDeliverDay;
                    productName[index] = res.data.productName;
                    submitRows[index].xiaFuJia = res.data.xiaFuJia;
                    submitRows[index].onhand = res.data.onhand;
                    submitRows[index].cadreRepertory = res.data.cadreRepertory;
                    submitRows[index].weiFaYunCount = res.data.weiFaYunCount;
                    submitRows[index].productionCycle = res.data.productionCycle;
                    submitRows[index].day = res.data.day;
                    submitRows[index].date = res.data.date;
                    submitRows[index].showPrice = res.data.listPrice;
                    self.setState({
                        day: day,
                        productionCycle: productionCycle,
                        date: date,
                        xiaFuJia: xiaFuJia,
                        jcxf: jcxf,
                        weiFaYunCount: weiFaYunCount,
                        priceRate: priceRate,
                        onhand: onhand,
                        cadreRepertory: cadreRepertory,
                        defDeliverDay: defDeliverDay,
                        productName: productName,
                        submitRows: submitRows
                    }, () => {
                        self.price();
                    })
                } else {
                    console.log(res);
                }
            })
        }
        this.setState({
            gatherRealityAddress2: value,  //实际收货地址选中
            gatherRealityAddress: detailAddress || '',
            recipientName: recipientName,
            mobile: mobile,
            receiveAddressId: receiveAddressId,
            xinzengShow: false,
            shouHuoShow: true,
            deliveryShowprice: deliveryShowPrice || 'Y'
        });
    }
    addressChange2 = (value, record, index) => {
        var self = this;
    }
    /*项目信息（含终端）选中*/
    terminalChange = (value) => {
        var messagess = this.state.optionTerminal.filter(x => x.id == value)[0];
        var projectId = messagess.id;
        var seller = messagess.seller;
        var projectMsg = messagess.projectMsg;
        var businessChannel = messagess.salesChannelCode;
        this.setState({
            terminalMessage: value,
            projectMessage: projectMsg,
            seller: seller,
            seller1: seller,
            projectId: value,
            businessChannel: businessChannel,
            businessChannel1: businessChannel
        });
        //如果特价的渠道是建筑，刷新归属渠道
        if (this.state.gsChannelCode == 'GMJ') {
            this.setState({businessChannel: this.state.gsChannelCode, seller: this.state.userName});
        }
    }
    /*订单类型选中*/
    terminalChange2 = (value) => {
        this.setState({
            partnerOrderType: value
        });
    }
    /*业务归属渠道选中*/
    terminalChange3 = (value) => {
        this.setState({
            businessChannel: value,
        });
    }
    /*备注信息填写*/
    remarkChange = (event) => {
        this.setState({
            remark: event.target.value
        });
    }
    changeRemark = (record, index, value) => {
        if (value.target.value.length > 100) {
            return
        }
        var submitRows = this.state.submitRows;
        submitRows[index].remark = value.target.value;
        this.setState({
            submitRows: submitRows
        });
    }

    deliveryTimeonChange = (index, value) => {
        var submitRows = this.state.submitRows;
        submitRows[index].deliveryArrivalDate = value;
        this.setState({
            submitRows: submitRows
        });
    };

    onChangeInputNumber = (record, index, value) => {
        const self = this;
        var submitRows = this.state.submitRows;
        var postCount = 0;
        var finishCount = 0;
        self.setState({
            usable: true,
        });

        if (value == "") {
            submitRows[index].count = 0;
        } else if (typeof value == 'string') {
            return
        }
        submitRows[index].count = value;
        var a = index;
        var postList = {
            channelCode: self.state.orderData.channelCode,
            customerId: parseInt(self.state.orderData.thirdId),
            purchaseId: self.state.detailData.id,
            pickProAddress: self.state.orgName || '',
            pickProAddressId: self.state.orgId || '',
            proId: self.state.submitRows[index].productId,
            count: self.state.submitRows[index].count || 0,
            receiveAddressId: self.state.receiveAddressId,
        };
        // console.log(postList)
        postCount++;
        getDongList(postList).then(res => {
            if (res.code == 200 && res.data) {
                finishCount++;
                if (postCount == finishCount) {
                    self.setState({
                        usable: false,
                    });
                }
                var day = self.state.day;
                var productionCycle = self.state.productionCycle;
                var date = self.state.date;
                var xiaFuJia = self.state.xiaFuJia;
                var jcxf = self.state.jcxf;
                var weiFaYunCount = self.state.weiFaYunCount;
                var priceRate = self.state.priceRate;
                var onhand = self.state.onhand;
                var cadreRepertory = self.state.cadreRepertory;
                var defDeliverDay = self.state.defDeliverDay;
                var productName = self.state.productName;
                day[index] = res.data.day;
                productionCycle[index] = res.data.productionCycle;
                date[index] = res.data.date;
                xiaFuJia[index] = res.data.xiaFuJia;
                jcxf[index] = res.data.jcxf;
                weiFaYunCount[index] = res.data.weiFaYunCount;
                priceRate[index] = res.data.priceRate;
                onhand[index] = res.data.onhand;
                cadreRepertory[index] = res.data.cadreRepertory;
                defDeliverDay[index] = res.data.defDeliverDay;
                productName[index] = res.data.productName;

                submitRows[index].xiaFuJia = res.data.xiaFuJia;
                submitRows[index].onhand = res.data.onhand;
                submitRows[index].cadreRepertory = res.data.cadreRepertory;
                submitRows[index].weiFaYunCount = res.data.weiFaYunCount;
                submitRows[index].productionCycle = res.data.productionCycle;
                submitRows[index].day = res.data.day;
                submitRows[index].date = res.data.date;
                submitRows[index].showPrice = res.data.listPrice;
                self.setState({
                    day: day,
                    productionCycle: productionCycle,
                    date: date,
                    xiaFuJia: xiaFuJia,
                    jcxf: jcxf,
                    onhand: onhand,
                    weiFaYunCount: weiFaYunCount,
                    priceRate: priceRate,
                    defDeliverDay: defDeliverDay,
                    productName: productName,
                    submitRows: submitRows
                }, () => {
                    self.price();
                })
            } else {
                console.log(res);
            }
        })
    }
    /*客户订单号填写*/
    customerOrderCodeChange = (event) => {
        this.setState({
            customerOrderCode: event.target.value
        });
    }

    customerProjectMsgChange = (event) => {
        this.setState({
            customerProjectMsg: event.target.value
        });
    }

    price = () => {
        var self = this;
        var price = 0;
        var allPrice = 0;
        var realyPrice = 0;
        var cutPrice = 0;
        var allRealyPrice = 0;
        var everyPrice = 0;
        var everyRealyPrice = 0;
        var everyCount = 0;
        for (var i = 0; i < self.state.submitRows.length; i++) {
            everyCount = self.state.submitRows[i].count || 0;
            everyPrice = self.state.submitRows[i].showPrice || 0;
            everyRealyPrice = self.state.xiaFuJia[i] || 0;
            allPrice = everyCount * everyPrice;
            price = price + allPrice;
            allRealyPrice = everyCount * everyRealyPrice;
            realyPrice = realyPrice + allRealyPrice;
            cutPrice = price - realyPrice;
        }
        var priceOfAll = price.toFixed(2);
        var priceOfRealy = realyPrice.toFixed(2);
        var priceOfCut = cutPrice.toFixed(2);
        self.setState({allPrice: priceOfAll, realyPrice: priceOfRealy, cutPrice: priceOfCut});
    }


    //离开当前路由时，更新store
    routeLeaveHook = (nextLocation) => {
    }

    componentWillMount = () => {
        const self = this;
        Notification.config({
            placement: 'topRight',
            top: 100,
            duration: 1,
        });
        window.myTemp = 1;
        var src = window.localStorage.getItem('server');
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
            passId: JSON.parse(localStorage.getItem('passId')),
            src: src,
        });
        if (self.props.params.id == 4) {
            var orderListData = this.state.orderListData;
            var submitRows = {...self.state.submitRows};
            var x = [];
            for (var i = 0; i < orderListData.length; i++) {
                // console.log(submitRows);
                x.push({
                    itemNum: orderListData[i].productCode || '',
                    count: orderListData[i].count || '',
                    proLine: orderListData[i].proLine || '',
                    productionCycle: orderListData[i].productionCycle || '',
                    pickProAddress: self.state.tiAddress2 || '',
                    productName: orderListData[i].name || '',
                    productId: orderListData[i].productId || '',
                    showPrice: orderListData[i].price || '',
                    remark: orderListData[i].remark || '',
                    stockType: orderListData[i].stockType || '',
                    unit: orderListData[i].unit || '',
                    packageQuantity: orderListData[i].packageQuantity || '',
                    minPackageQuantity: orderListData[i].minPackageQuantity || '',
                    shoppingcartId: orderListData[i].id || '',
                    customerOrderLine: orderListData[i].customerOrderLine || '',
                    maxAcceptQty: orderListData[i].maxAcceptQty || '',
                    id: window.myTemp++
                })
            }
            self.setState({submitRows: x})
        }
        if (self.props.params.id == 5) {
            var dingPassParse = this.state.dingPassParse;
            var submitRows = [...self.state.submitRows];
            for (var i = 0; i < dingPassParse.length; i++) {
                // console.log(submitRows);
                // console.log(dingPassParse[i])
                var x = {
                    itemNum: dingPassParse[i].erpData.ITEM_NUM || '',
                    count: dingPassParse[i].count || '',
                    proLine: dingPassParse[i].proLine || '',
                    productionCycle: dingPassParse[i].productionCycle || '',
                    pickProAddress: self.state.tiAddress2 || '',
                    productName: dingPassParse[i].erpData.ITEM_DESC || '',
                    productId: dingPassParse[i].productId || '',
                    showPrice: dingPassParse[i].erpData.PRICE || '',
                    //remark: dingPassParse[i].remark || '',
                    stockType: dingPassParse[i].stockType || '',
                    unit: dingPassParse[i].unit || '',
                    packageQuantity: dingPassParse[i].packageQuantity || '',
                    minPackageQuantity: dingPassParse[i].minPackageQuantity || '',
                    // shoppingcartId: dingPassParse[i].id || '',
                    bookId: dingPassParse[i].bookId || '',
                    customerOrderLine: dingPassParse[i].customerOrderLine || '',
                    maxAcceptQty: dingPassParse[i].maxAcceptQty || '',
                    id: window.myTemp++,
                }
                submitRows.push(x);
            }
            self.setState({submitRows})
        }
        if (self.props.params.id == 6) {
            var passParse = this.state.passParse;
            var submitRows = [...self.state.submitRows];
            var orderData = {...self.state.orderData};
            var detailData = {...self.state.detailData};
            for (var i = 0; i < passParse.length; i++) {
                var x = {
                    itemNum: passParse[i].proCode || '',
                    count: passParse[i].commitQuantity2 || '',
                    proLine: passParse[i].proLine || '',
                    // lineId: passParse[i].lineId || '',
                    productionCycle: passParse[i].productionCycle || '',
                    pickProAddress: passParse[i].orgName || '',
                    pickProAddressId: passParse[i].orgId || '',
                    delvId: passParse[i].orgId || '',
                    productName: passParse[i].proDesc || '',
                    productId: passParse[i].productId || '',
                    showPrice: passParse[i].showPrice || '',
                    remark: passParse[i].remark || '',
                    stockType: passParse[i].stockType || '',
                    unit: passParse[i].unit || '',
                    packageQuantity: passParse[i].packageQuantity || '',
                    minPackageQuantity: passParse[i].minPackageQuantity || '',
                    reserveLid: passParse[i].lineId || '',
                    customerOrderLine: passParse[i].customerOrderLine || '',
                    maxAcceptQty: passParse[i].maxAcceptQty || '',
                    id: window.myTemp++,
                }
                submitRows.push(x);
            }
            self.setState({submitRows});
            orderData.PurchaseUnit = passParse[0].buyCompanyName;
            orderData.channel = passParse[0].channel;
            orderData.thirdId = parseInt(passParse[0].cusId);
            orderData.channelCode = passParse[0].channelCode;
            orderData.cusId = parseInt(passParse[0].cusId);
            orderData.cusName = parseInt(passParse[0].cusId);
            detailData.cusName = passParse[0].customerName;
            detailData.status = passParse[0].status;
            detailData.id = parseInt(passParse[0].buyCompanyId);
            detailData.customerName = passParse[0].customerName;
            detailData.cusCode = passParse[0].customerCode;
            getGdList({
                customerId: parseInt(passParse[0].cusId),
                channelCode: passParse[0].channelCode,
                p: 1,
                s: 10,
                purchaseId: passParse[0].buyCompanyId
            }).then(result => {
                if (result.status && result.data.length > 0) {
                    orderData.defDiscount = result.data[0].defDiscount;
                    orderData.sxeAmount = result.data[0].sxeAmount;
                } else {
                    message.error(result.message);
                }
            });
            self.setState({
                orderData,
                detailData,
                purchaseId: passParse[0].buyCompanyId,
                channelCode: passParse[0].channel,
                headerId: passParse[0].headerId,
                reserveHid: passParse[0].headerId,
                id6: true,
                remark: '预订单编号:' + passParse[0].headerId,
            });
        }
        /*从编辑进入详情*/
        if (self.props.params.id == 9) {
            var orderData = {...self.state.orderData};
            var detailData = {...self.state.detailData};
            // let self = this;
            /*获取订单详情*/
            getOrderDetails({id: self.props.params.orderId}).then(function (result) {
                if (result && result.code == 200) {
                    var passParse = result.data.productList;
                    var passDetail = result.data;
                    orderData.PurchaseUnit = passDetail.buyCompany;
                    orderData.channel = passDetail.channel;
                    orderData.thirdId = parseInt(passDetail.cusId);
                    orderData.channelCode = passDetail.channelCode;
                    orderData.cusId = parseInt(passDetail.cusId);
                    orderData.cusName = parseInt(passDetail.cusId);
                    orderData.orderSource = passDetail.orderSource;
                    detailData.createdDate = passDetail.createdDate;
                    detailData.cusName = passDetail.customerName;
                    detailData.status = passDetail.status;
                    detailData.id = parseInt(passDetail.buyCompanyId);
                    detailData.customerName = passDetail.customerName;
                    detailData.cusCode = passDetail.customerCode;
                    // console.log(orderData);
                    // console.log(detailData.id);
                    // orderData.defDiscount = passDetail.discountRate;//改为手输开单
                    orderData.sxeAmount = passDetail.remainingSum;
                    orderData.sourceNo = passDetail.sourceNo;
                    if (passDetail.orderSubmit == false) {
                        orderData.orders = 1;
                        self.setState({orderSubmit3: 'none', orderSubmit2: 'block'})
                    } else {
                        orderData.orders = 0;
                        self.setState({orderSubmit3: 'block', orderSubmit2: 'none'})
                    }
                    if (passDetail.orderStatus == 1 && passDetail.getProCode != null) {
                        self.setState({orderSubmit4: 'block'})
                    }
                    self.setState({
                        orderData,
                        detailData,
                        purchaseId: passDetail.buyCompanyId,
                        channelCode: passDetail.channelCode,
                        deliveryShowprice: passDetail.deliveryShowprice,
                        // headerId:passDetail.headerId
                        defDiscount: passDetail.discountRate,
                        id6: passDetail.reserveHid ? true : false,
                        status: passDetail.erpStatus,
                        sourceNo: passDetail.sourceNo
                    });
                    var submitRows = [...self.state.submitRows];
                    var postCount = 0;
                    var finishCount = 0;
                    self.setState({
                        usable: true,
                    });

                    //编辑进去后刷新特价
                    if (self.props.params.type != '再来一单') {
                        if (passDetail.specialOfferCode != null) {
                            for (var i = 0; i < passParse.length; i++) {
                                self.gettejia2(passParse[i].productId, passDetail.specialOfferCode);
                            }
                            giveTeJia2(self.state.getTjList).then(result => {
                                if (result.code == 200 && result.data) {
                                    self.setState({tjlist: result.data}, () => {
                                        self.tick();
                                    });
                                }
                            });
                        }
                    }

                    for (let i = 0; i < passParse.length; i++) {
                        if (passParse[i].orderProductPartList) {
                            for (let j = 0; j < passParse[i].orderProductPartList.length; j++) {
                                passParse[i].orderProductPartList[j].appointDeliveryDate = moment(passParse[i].orderProductPartList[j].appointDeliveryDate)
                            }
                        }

                        var x = {
                            itemNum: passParse[i].productCode || '',
                            count: passParse[i].count || '',
                            proLine: passParse[i].proLine || '',
                            lineId: passParse[i].lineId || '',
                            reserveLid: passParse[i].reserveLid || '',
                            // pickProAddressId:parseInt(passParse[i].delvId) || '',
                            productName: passParse[i].productName || '',
                            productId: passParse[i].productId || '',
                            showPrice: passParse[i].originalPrice || '',
                            remark: passParse[i].remark || '',
                            stockType: passParse[i].stockType || '',
                            unit: passParse[i].unit || '',
                            packageQuantity: passParse[i].packageQuantity || '',
                            minPackageQuantity: passParse[i].minPackageQuantity || '',
                            productionCycle: passParse[i].productionCycle || '',
                            cadreRepertory: passParse[i].cadreRepertory || '',
                            pickProAddress: passParse[i].pickProAddress || '',
                            priceRate: passParse[i].priceRate || '',
                            delvId: passParse[i].delvId || '',
                            orderProductPartList: passParse[i].orderProductPartList || '',
                            id: window.myTemp++,
                            faYunCount: passParse[i].faYunCount || '',
                            weiFaYunCount: passParse[i].weiFaYunCount || '',
                            customerOrderLine: passParse[i].customerOrderLine || '',
                            offerLineId: passParse[i].offerLineId || '',
                            noshowOnhand: passParse[i].noshowOnhand || '',
                            maxAcceptQty: passParse[i].maxAcceptQty || '',
                            deliveryArrivalDate: passParse[i].deliveryArrivalDate || '',
                            capacityControl: passParse[i].capacityControl || '',
                        }
                        submitRows.push(x);
                        var postList = {
                            channelCode: passDetail.channelCode,
                            customerId: parseInt(passDetail.cusId),
                            purchaseId: passDetail.buyCompanyId,
                            pickProAddress: passParse[i].pickProAddress || '',
                            pickProAddressId: parseInt(passParse[i].delvId) || '',
                            proId: passParse[i].productId,
                            count: passParse[i].count || 0,
                            receiveAddressId: passDetail.gatherAddressId,
                        };
                        postCount++;
                        getDongList(postList).then(res => {
                            if (res.code == 200 && res.data) {
                                finishCount++;
                                if (postCount == finishCount) {
                                    self.setState({
                                        usable: false,
                                    });
                                }
                                var day = self.state.day;
                                var date = self.state.date;
                                var xiaFuJia = self.state.xiaFuJia;
                                var jcxf = self.state.jcxf;
                                var weiFaYunCount = self.state.weiFaYunCount;
                                var onhand = self.state.onhand;
                                var priceRate = self.state.priceRate;
                                var cadreRepertory = self.state.cadreRepertory;
                                var productionCycle = self.state.productionCycle;
                                var defDeliverDay = self.state.defDeliverDay;
                                var productName = self.state.productName;
                                day[i] = res.data.day;
                                date[i] = res.data.date;
                                xiaFuJia[i] = res.data.xiaFuJia;
                                jcxf[i] = res.data.jcxf;
                                weiFaYunCount[i] = res.data.weiFaYunCount;
                                onhand[i] = res.data.onhand;
                                priceRate[i] = res.data.priceRate;
                                cadreRepertory[i] = res.data.cadreRepertory;
                                productionCycle[i] = res.data.productionCycle;
                                defDeliverDay[i] = res.data.defDeliverDay;
                                productName[i] = res.data.productName;
                                submitRows[i].xiaFuJia = res.data.xiaFuJia;
                                submitRows[i].onhand = res.data.onhand;
                                submitRows[i].cadreRepertory = res.data.cadreRepertory;
                                submitRows[i].weiFaYunCount = res.data.weiFaYunCount;
                                submitRows[i].productionCycle = res.data.productionCycle;
                                submitRows[i].day = res.data.day;
                                submitRows[i].date = res.data.date;
                                submitRows[i].showPrice = res.data.listPrice;
                                // debugger
                                self.setState({
                                    day: day,
                                    date: date,
                                    xiaFuJia: xiaFuJia,
                                    jcxf: jcxf,
                                    weiFaYunCount: weiFaYunCount,
                                    onhand: onhand,
                                    defDeliverDay: defDeliverDay,
                                    productionCycle: productionCycle,
                                    productName: productName,
                                    submitRows: submitRows,
                                    receiveAddressId: passDetail.gatherAddressId,
                                    remark: passDetail.remark,
                                    // remark44:passDetail.salesmanName,
                                    // salesmanName:passDetail.salesmanName,
                                    recipientName: passDetail.contacts,
                                    mobile: passDetail.phone,
                                    id: passDetail.id,
                                    delvId: passParse[i].delvId,
                                    gatherRealityAddress: passDetail.gatherRealityAddress.toString(),
                                    gatherRealityAddress1: passDetail.gatherRealityAddress.toString(),
                                    gatherRealityAddress2: passDetail.gatherAddressId.toString(),
                                    projectId: passDetail.projectId,
                                    terminalMessage: passDetail.projectId.toString(),
                                    // defaultAddress: passDetail.defaultAddress.toString(),
                                    projectMessage: passDetail.projectMessage.toString(),
                                    allPrice: passDetail.amount,
                                    createdBy: passDetail.createdBy,
                                    realyPrice: passDetail.realityAmount,
                                    cutPrice: (passDetail.amount - passDetail.realityAmount).toFixed(6),
                                    // remark11: passDetail.completeFactory,
                                    // remark22: passDetail.closeHomologous,
                                    // remark33: passDetail.projectAddMsg,
                                    specCode1: passDetail.specialOfferCode,
                                    specialOfferCode: passDetail.specialOfferCode,
                                    projectCooperation: passDetail.projectCooperation,
                                    contractOrderCode: passDetail.contractNum,
                                    contractOrderName: passDetail.contractOrderName,
                                    contractId: passDetail.contractId,
                                    subsidiaryName: passDetail.subsidiaryName,
                                    // informationLi: passDetail.fileUrls,
                                    // 合作伙伴订单新增
                                    pullChannel: passDetail.pullChannel,
                                    pullmanName: passDetail.pullmanName,
                                    subsidiaryId: passDetail.subsidiaryId,
                                    partnerOrderType: passDetail.partnerOrderType,
                                    pickProAddress: passDetail.pickProAddress,
                                    gatherCity: passDetail.gatherCity,
                                    gatherCityId: passDetail.gatherCityId,
                                    lineId: passDetail.gatherCityId,
                                    customerOrderCode: passDetail.customerOrderCode,
                                    customerProjectMsg: passDetail.customerProjectMsg,
                                    businessChannel: passDetail.businessChannel,
                                    seller: passDetail.salesmanName,
                                    orgId: passParse[i].delvId,
                                    orgName: passParse[i].pickProAddress,
                                    province1: passDetail.province1,
                                    province: passDetail.province1,
                                    getProCode: passDetail.getProCode,
                                    giveBackStatus: passDetail.orderStatus || 0,
                                    headerId2: passDetail.headerId,
                                    guiShu1: passDetail.specialOfferCode,
                                    apiFlag: passDetail.orderSource ? true : false
                                }, () => {
                                    if (self.props.params.id == 9) {
                                        var state = {...self.state};
                                        if (self.props.params.type && self.props.params.type == '再来一单') {
                                            for (let i = 0; i < submitRows.length; i++) {
                                                submitRows[i].reserveLid = null;
                                                submitRows[i].offerLineId = null;
                                            }
                                            delete self.state.getProCode;
                                            delete self.state.orderData.gatherCityId;
                                            delete self.state.orderData.gatherCity;
                                            delete self.state.gatherCity;
                                            delete self.state.gatherCityId;
                                            delete self.state.orgName;
                                            delete self.state.guiShu1;
                                            delete self.state.specCode1;
                                            delete self.state.specialOfferCode;
                                            delete self.state.apiFlag;
                                            delete self.state.customerOrderCode;
                                            delete self.state.customerProjectMsg;
                                            delete self.state.remark;
                                            delete self.state.orderData.orderSource;
                                            delete self.state.orderData.sourceNo;
                                            delete self.state.receiveAddressId;
                                            delete self.state.gatherRealityAddress;
                                            delete self.state.gatherRealityAddress2;
                                            self.setState({state: state, submitRows: submitRows, sourceNo: null});
                                        }
                                    }
                                })
                            } else {
                                console.log(res);
                            }
                        })
                    }
                    // console.log(submitRows);
                    self.setState({submitRows}, () => {
                        self.initData();
                    });
                }
            });
        }
    }

    componentDidMount = () => {
        const self = this;
        if (this.props.params.id != 9) {
            this.initData();
            self.setState({apiFlag: false});
        }
        if (self.state.orderData.orders == 1) {
            self.setState({orderSubmit3: 'none', orderSubmit2: 'block'});
        }

        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }


    handleOk = () => {
        this.setState({visible: false});
    }
    handleOk2 = (value, record, index) => {
        this.setState({modalVisible: false, dataSource2: [], dataSource3: ''});
    }
    handleOk3 = (value, record, index) => {
        this.setState({visible2: false});
    }
    handleCancel = () => {
        this.setState({visible: false});
    }
    handleCancel2 = () => {
        this.setState({modalVisible: false, dataSource2: [], dataSource3: ''});
    }
    handleCancel3 = () => {
        this.setState({visible2: false});
    }
    handleCancel4 = () => {
        this.setState({visible3: false});
    }
    addFenPi = () => {
        const {count2, dataSource2, number2} = this.state;
    }
    deleteFenPi = () => {
        const {count2, dataSource2, number2} = this.state;
    }
    handleChange = (index, value) => {
        var dataSource2 = [...this.state.dataSource2];
        dataSource2[index].appointDeliveryDate = value;
        this.setState({dataSource2: dataSource2});
    }

    onOkData = (text, record, value) => {
        console.log('onOk: ', value);
    }
    handleAdd2 = () => {
        const {count2, dataSource2, number2} = this.state;
        const newData2 = {
            key: count2,
            startCount: '',
            endCount: '',
            discountCategory: '',
            discount: '',
            removeFlag2: 0,
            number2: number2
        };
        this.setState({
            dataSource2: [...dataSource2, newData2],
            count2: count2 + 1,
            number2: number2 + 1
        });
    }
    onCellChange2 = (record, index, value) => {
        const self = this;
        const dataSource2 = [...this.state.dataSource2];
        dataSource2[index].deliveryCount = value.target.value;
        this.setState({dataSource2: dataSource2});
    }
    onDelete2 = (key) => {
        const self = this;
        const dataSource2 = [...this.state.dataSource2];
        dataSource2.splice(key, 1);
        for (var i = 0; i < dataSource2.length; i++) {
            if (dataSource2[i] == "" || typeof (dataSource2[i]) == "undefined") {
                dataSource2.splice(i, 1);
                i = i - 1;
            }
        }
        this.setState({dataSource2: dataSource2})
    }
    saveFenPi = (record, index, value) => {
        var submitRows = [...this.state.submitRows];
        var dataSource2 = [...this.state.dataSource2];
        var dataSource3 = parseInt(this.state.dataSource3);
        submitRows[dataSource3].orderProductPartList = dataSource2
        for (var i = 0; i < this.state.submitRows.length; i++) {
            if (this.state.submitRows[i].orderProductPartList && this.state.submitRows[i].orderProductPartList.length > 0) {
                for (let j = 0; j < this.state.submitRows[i].orderProductPartList.length; j++) {
                    this.state.submitRows[i].orderProductPartList[j].logisticsCycle = this.state.defDeliverDay[i];
                    this.state.submitRows[i].orderProductPartList[j].productName = this.state.productName2[i];
                    delete this.state.submitRows[i].orderProductPartList[j].key;
                    delete this.state.submitRows[i].orderProductPartList[j].startCount;
                    delete this.state.submitRows[i].orderProductPartList[j].endCount;
                    delete this.state.submitRows[i].orderProductPartList[j].discountCategory;
                    delete this.state.submitRows[i].orderProductPartList[j].discount;
                    delete this.state.submitRows[i].orderProductPartList[j].removeFlag2;
                    delete this.state.submitRows[i].orderProductPartList[j].number2;
                }
            }
        }
        var x = 0;
        var y = 0;
        var date = new Date();
        var date2 = new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
        for (var k = 0; k < dataSource2.length; k++) {
            x = x + parseInt(dataSource2[k].deliveryCount);
            // console.log(dataSource2[k].appointDeliveryDate);
            if (!dataSource2[k].appointDeliveryDate || dataSource2[k].appointDeliveryDate < date || dataSource2[k].appointDeliveryDate > date2) {
                y = 1
            }
        }
        submitRows[dataSource3].faYunCount = x;
        if (x != submitRows[dataSource3].count) {
            openNotice('warning', '请确认发货数量');
        } else if (y == 1) {
            openNotice('warning', '请确认发货日期');
        } else {
            this.setState({submitRows: submitRows});
            this.setState({dataSource2: []});
            this.setState({modalVisible: false});
        }
    }
    openCity = () => {
        this.setState({visible2: true})
        this.getAddArray2();
    }
    openCity2 = () => {
        this.setState({visible3: true})
        this.getAddArray3();
    }
    openCity3 = () => {
        const self = this;
        if (self.state.guiShu1) {
            confirm({
                content: '选择特价将重置已选择的商品信息,确定吗?',
                onOk() {
                    self.setState({
                        visible4: true,
                    })
                    self.getAddArray4();
                },
                onCancel() {
                    return
                }
            })
        } else {
            self.setState({visible4: true});
            self.getAddArray4();
        }
    }

    onSelectRadio4 = (record, selected, selectedRows) => {
        let businessLines = [];
        businessLines.push(record.cooperateBusiness);
        businessLines.push(record.zdBusiness);
        businessLines.push(record.projectBusiness);
        businessLines.push(record.finalBusiness);

        if (record.channelCode == 'GMJ') {
            this.setState({
                guiShu1: record.specCode,
                specCode1: record.specCode,
                gsChannelCode: record.channelCode,
                pullmanName: record.pullName,
                pullChannel: record.pullChannelCode,
                userName: record.userName,
                businessChannel: record.channelCode,
                businessChannel1: record.channelCode,
                seller: record.userName,
                seller1: record.userName,
                terminalMessage: record.terminalId ? record.terminalId.toString() : '',
                projectMessage: record.terminalName,
                projectId: record.terminalId ? record.terminalId.toString() : '',
                cooperateBusiness: record.cooperateBusiness,
                zdBusiness: record.zdBusiness,
                projectBusiness: record.projectBusiness,
                finalBusiness: record.finalBusiness,
                businessLines: businessLines,
                subsidiaryId: record.subsidiaryId,
                subsidiaryName: record.subsidiaryName
            });
        } else {
            this.setState({
                guiShu1: record.specCode,
                specCode1: record.specCode,
                gsChannelCode: record.channelCode,
                pullmanName: record.pullName,
                pullChannel: record.pullChannelCode,
                userName: record.userName,
                businessChannel: record.businessChannel,
                businessChannel1: record.businessChannel,
                seller: record.salesman,
                seller1: record.salesman,
                terminalMessage: record.terminalId ? record.terminalId.toString() : '',
                projectMessage: record.terminalName,
                projectId: record.terminalId ? record.terminalId.toString() : '',
                cooperateBusiness: record.cooperateBusiness,
                zdBusiness: record.zdBusiness,
                projectBusiness: record.projectBusiness,
                finalBusiness: record.finalBusiness,
                businessLines: businessLines,
                subsidiaryId: record.subsidiaryId,
                subsidiaryName: record.subsidiaryName
            });
        }
        //如果特价是建筑渠道，刷新业务归属渠道
        /*if (record.channelCode == 'GMJ') {
            this.setState({businessChannel: record.channelCode, seller: record.userName});
        } else {
            this.setState({businessChannel: this.state.businessChannel1, seller: this.state.seller1});
        }*/
        //李 新增
        //分页查询在只有将页码赋值到第一页才能在当前页查询不同页码内的数据
        if (record.specCode != this.state.lastsearch) {
            this.state.addSearchObj5.p = 1;
            this.state.lastsearch = record.specCode;
        }
        //翻页的方法
        getPro5({
            specCode: record.specCode,
            p: this.state.addSearchObj5.p,
            s: this.state.addSearchObj5.s
        }).then(result => {
            if (result.status && result.code == 200) {
                // console.log(record.specCode)
                // debugger
                var data = result.data;
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].id = i + 1;
                }
                this.setState({
                    specCode1: record.specCode,
                    addRows5: data,
                    addTotal5: result.total,
                    // tiAddress: result,
                });
            } else {
                message.error(result.message);
            }
        })

        var submitRows = [...this.state.submitRows];
        var tjlist = [];
        for (var i = 0; i < submitRows.length; i++) {
            const promise = this.gettejia(submitRows[i].productId, record.specCode);
            promise.then(result => {
                tjlist.push(result.data);
                this.setState({...this.state.tjlist, tjlist});
            })
        }
        this.setState({...this.state.tjlist, tjlist}, () => {
            this.interval = setInterval(() => this.tick(), 3000);
        });

    }

    tick = () => {
        clearInterval(this.interval);
        var submitRows = [...this.state.submitRows];
        var tjlist = [...this.state.tjlist];
        submitRows.map(item => {
            tjlist.map(itm => {
                if (item.itemNum == itm.proCode) {
                    if (itm.terminalPriceRate == '' && itm.terminalUnitPrice == '') {
                        item.specialFlag = 0;
                    } else {
                        item.specialFlag = 1;
                    }
                    item.offerLineId = itm.offerLineId;
                }
            })
        })
        this.setState({...this.state.submitRows, submitRows});
    }

    async gettejia(productId, specCode) {
        const result = await giveTeJia({
            customerId: parseInt(this.state.orderData.thirdId),
            proId: productId,
            purchaseId: this.state.detailData.id,
            channelCode: this.state.channelCode,
            flowCode: specCode,
        })
        return result;
    }

    gettejia2(productId, specCode) {
        const getTjList = [...this.state.getTjList];
        getTjList.push({
            customerId: parseInt(this.state.orderData.thirdId),
            proId: productId,
            purchaseId: this.state.detailData.id,
            channelCode: this.state.channelCode,
            flowCode: specCode,
        });
        this.setState({getTjList});
    }

    resetView = () => {
        window.location.reload();
    }
    changeDefDisCount = (e) => {
        var x = Math.round(e);
        this.setState({defDiscount: x});
        // debugger
    }

    showModal = () => {
        this.setState({
            confirmvisible: true,
        });
    }
    handleCancel5 = () => {
        this.setState({
            confirmvisible: false,
            confirmLoading: false,
        });
    }
    handleCancel6 = () => {
        this.setState({visible4: false});
    }
    //导入
    importLineData = (res) => {
        const self = this;
        // console.log(res);
        var passParse = res.data;
        if (res.msg && res.msg != '' && res.msg != 'null') {
            message.warning(res.msg);
        }
        if (res.data == null) {
            message.warning('导入失败');
            return
        }

        var submitRows = [...self.state.submitRows];
        for (let i = 0; i < passParse.length; i++) {
            var x = {
                itemNum: passParse[i].productCode || '',
                count: passParse[i].count || '',
                proLine: passParse[i].proLine || '',
                // lineId : passParse[i].lineId  || '',
                // pickProAddressId:parseInt(passParse[i].delvId) || '',
                productName: passParse[i].productName || '',
                productId: passParse[i].productId || '',
                showPrice: passParse[i].originalPrice || '',
                remark: passParse[i].remark || '',
                stockType: passParse[i].stockType || '',
                unit: passParse[i].unit || '',
                packageQuantity: passParse[i].packageQuantity || '',
                minPackageQuantity: passParse[i].minPackageQuantity || '',
                // productionCycle :  passParse[i].productionCycle || '',
                // cadreRepertory :  passParse[i].cadreRepertory || '',
                pickProAddress: passParse[i].pickProAddress || '',
                priceRate: passParse[i].priceRate || '',
                delvId: passParse[i].delvId || '',
                reserveLid: passParse[i].reserveLid || '',
                maxAcceptQty: passParse[i].maxAcceptQty || '',
                id: window.myTemp++,
                specialFlag: 0
            }

            giveTeJia({
                customerId: parseInt(self.state.orderData.thirdId),
                proId: passParse[i].productId,
                purchaseId: self.state.detailData.id,
                channelCode: self.state.channelCode,
                flowCode: self.state.guiShu1,
            }).then(result => {
                if (result.data.terminalPriceRate == '' && result.data.terminalUnitPrice == '') {
                    x.specialFlag = 0;
                } else {
                    x.specialFlag = 1;
                }
                x.offerLineId = result.data.offerLineId;
            })

            submitRows.push(x);

            self.setState({submitRows});
        }
        self.refresh();
    }

    refresh() {
        const self = this;
        var submitRows = [...self.state.submitRows];
        var postCount = 0;
        var finishCount = 0;
        self.setState({
            usable: true,
        });
        var day = self.state.day;
        var date = self.state.date;
        var xiaFuJia = self.state.xiaFuJia;
        var jcxf = self.state.jcxf;
        var weiFaYunCount = self.state.weiFaYunCount;
        var onhand = self.state.onhand;
        var productionCycle = self.state.productionCycle;
        var defDeliverDay = self.state.defDeliverDay;
        var productName = self.state.productName;
        var priceRate = self.state.priceRate;
        var cadreRepertory = self.state.cadreRepertory;
        self.setState({
            day: [],
            date: [],
            xiaFuJia: [],
            jcxf: [],
            onhand: [],
            weiFaYunCount: [],
            defDeliverDay: [],
            productionCycle: [],
            cadreRepertory: [],
            productName: [],
            priceRate: [],
        })
        for (let t = 0; t < self.state.submitRows.length; t++) {
            var postList = {
                channelCode: self.state.orderData.channelCode,
                customerId: self.state.orderData.thirdId,
                purchaseId: self.state.detailData.id,
                pickProAddress: submitRows[t].pickProAddress || '',
                pickProAddressId: parseInt(submitRows[t].delvId) || '',
                proId: submitRows[t].productId,
                count: submitRows[t].count || 0,
                receiveAddressId: self.state.receiveAddressId,
            };
            postCount++;
            getDongList(postList).then(res => {
                if (res.code == 200 && res.data) {
                    finishCount++;
                    if (postCount == finishCount) {
                        self.setState({
                            usable: false,
                        });
                    }
                    var day = self.state.day;
                    var date = self.state.date;
                    var xiaFuJia = self.state.xiaFuJia;
                    var jcxf = self.state.jcxf;
                    var weiFaYunCount = self.state.weiFaYunCount;
                    var onhand = self.state.onhand;
                    var productionCycle = self.state.productionCycle;
                    var defDeliverDay = self.state.defDeliverDay;
                    var productName = self.state.productName;
                    var priceRate = self.state.priceRate;
                    var cadreRepertory = self.state.cadreRepertory;
                    day[t] = res.data.day;
                    date[t] = res.data.date;
                    xiaFuJia[t] = res.data.xiaFuJia;
                    jcxf[t] = res.data.jcxf;
                    weiFaYunCount[t] = res.data.weiFaYunCount;
                    onhand[t] = res.data.onhand;
                    productionCycle[t] = res.data.productionCycle;
                    defDeliverDay[t] = res.data.defDeliverDay;
                    productName[t] = res.data.productName;
                    cadreRepertory[t] = res.data.cadreRepertory;
                    priceRate[t] = res.data.priceRate;
                    submitRows[t].xiaFuJia = res.data.xiaFuJia;
                    submitRows[t].onhand = res.data.onhand;
                    submitRows[t].cadreRepertory = res.data.cadreRepertory;
                    submitRows[t].weiFaYunCount = res.data.weiFaYunCount;
                    submitRows[t].productionCycle = res.data.productionCycle;
                    submitRows[t].day = res.data.day;
                    submitRows[t].date = res.data.date;
                    submitRows[t].showPrice = res.data.listPrice;
                    self.setState({
                        day: day,
                        date: date,
                        xiaFuJia: xiaFuJia,
                        jcxf: jcxf,
                        weiFaYunCount: weiFaYunCount,
                        onhand: onhand,
                        priceRate: priceRate,
                        cadreRepertory: cadreRepertory,
                        productionCycle: productionCycle,
                        defDeliverDay: defDeliverDay,
                        productName: productName,
                    }, () => {
                        self.price();
                    })
                }
            })
        }
    }

    haveReceiveId = () => {
        if (!this.state.receiveAddressId) {
            message.warning('请选择实际收货地址');
            return
        }
    }
    /*存在未发运确认*/

    render = () => {
        var self = this;
        var lines = '例如生产周期为[1,3]表示：类型为库存类的产品，有库存时生产需要1天，无库存时生产需要3天。\n' +
            '类型为非库存类的产品，显示为准确的生产天数';
        const {
            cityShow,
            shouHuoShow,
            opts,
            key,
            total,
            searchObj,
            jcxf,
            selectedRowKeys,
            selectedRowKeysOutside,
            selectedRowKeys2,
            selectedRowKeys3,
            selectedRowKeys4,
            selectedRowKeysOutside2,
            visible,
            visible2,
            visible3,
            visible4,
            modalVisible,
            addRows,
            addTotal,
            addRows2,
            addTotal2,
            addRows3,
            addTotal3,
            addRows4,
            addRows5,
            addTotal4,
            addTotal5,
            addSearchObj,
            addSearchObj2,
            addSearchObj3,
            addSearchObj4,
            addSearchObj5,
            phone,
            orderData,
            detailData,
            optionAddress,
            optionTerminal,
            remark,
            valueRemark,
            customerOrderCode,
            button_limits_end,
            mobile,
            kaiCount,
            recipientName,
            seller,
            tiAddress,
            orgName,
            orgId,
            src,
            day,
            date,
            onhand,
            cadreRepertory,
            defDeliverDay,
            productionCycle,
            productName,
            weiFaYunCount,
            xiaFuJia,
            priceRate,
            xinzengShow,
            allPrice,
            realyPrice,
            cutPrice,
            onOkData,
            dataSource2,
            dataSource3,
            gatherRealityAddress2,
            terminalMessage,
            orderSubmit3,
            orderSubmit2,
            orderSubmit4,
            id6,
            confirmLoading,
            confirmvisible,
            pullmanName,
            quickVisible,
            quickString,
            quickLoading,
            cascaderValue,
            tree,
            ts_disabled,
            ts_checked,
            ls_checked,
            loading,
            apiFlag,
            customerProjectMsg
        } = this.state;
        const disabledDate = (current) => {
            return current && current.valueOf() < Date.now() || current && current.valueOf() > (Date.now() + 30 * 24 * 60 * 60 * 1000);
        }
        const disabledDeliveryDate = (current) => {
            return current && current < moment().startOf('day');
        }
        let uploadParam = toImportExcel1(
            3,
            self.state.orderData.channelCode,
            parseInt(self.state.orderData.thirdId),
            self.state.detailData.id,
            self.state.receiveAddressId,
            '',
            self.state.orgName || '',
            (result) => {
                this.importLineData(result)
            }
        );
        const fenPiFaYun = {
            size: 'small',
            pagination: false,
            bordered: true,
            dataSource: this.state.dataSource2,
            columns: [
                {
                    title: '约定发货日期',
                    dataIndex: 'appointDeliveryDate',
                    render: (text, record, index) => {
                        return (<DatePicker
                            showTime
                            value={text}
                            format="YYYY-MM-DD"
                            disabledDate={disabledDate}
                            placeholder="选择时间"
                            onChange={this.handleChange.bind(this, index)}
                        />)
                    }
                },
                {
                    title: '默认发货周期（天）',
                    dataIndex: 'logisticsCycle',
                    render: (text, record, index) => {
                        return <span>{this.state.defDeliverDay[dataSource3] || 0}</span>
                    }
                },
                {
                    title: '发货数量',
                    dataIndex: 'deliveryCount',
                    render: (text, record, index) => {
                        return (<span><Input
                            defaultValue={text}
                            onChange={this.onCellChange2.bind(this, record, index)}
                        /></span>)
                    }
                },
                {
                    title: '物料名称',
                    dataIndex: 'productName',
                    render: (text, record, index) => {
                        return <span>{this.state.productName2 || 0}</span>
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: '200',
                    render: (text, record, index) => {
                        const {dataSource2} = this.state;
                        return (
                            dataSource2.length > 0 ?
                                (
                                    <a onClick={() => this.onDelete2(index)}>删除</a>
                                ) : null
                        );
                    }
                }
            ],
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            scroll: {x: 2000, y: false},
            columns: [
                {
                    title: '序号',
                    width: 50,
                    dataIndex: 'id',
                    render: (text, record, index) => {
                        return index + 1
                    }
                },
                {
                    title: '产品线',
                    dataIndex: 'proLine',
                    width: 70,
                    render: (text) => {
                        switch (text) {
                            case '01' || '元器件':
                                return <span>{'元器件'}</span>;
                                break;
                            case '02' || '电工':
                                return <span>{'电工'}</span>;
                                break;
                            case '03' || '电表':
                                return <span>{'电表'}</span>;
                                break;
                            case '04' || '变频器':
                                return <span>{'变频器'}</span>;
                                break;
                            case '05' || '天e':
                                return <span>{'天e'}</span>;
                                break;
                            case '06' || 'TG精品':
                                return <span>{'TG精品'}</span>;
                                break;
                        }
                    }
                },
                {
                    title: '物料编码',
                    width: 120,
                    dataIndex: 'itemNum',
                    render: (text, record, index) => {
                        return (
                            <div>
                                <span>{text}</span>
                                {!record.specialFlag ?
                                    <Tag color="red" style={{float: 'right', cursor: 'default'}}>无特价</Tag> : null}
                                {record.stockType == '定制' ?
                                    <Tag color="green"
                                         style={{float: 'right', cursor: 'default'}}>定制开单</Tag> : null}
                            </div>
                        )
                    }
                },
                {
                    title: '物料描述',
                    width: 210,
                    dataIndex: 'productName'
                },
                {
                    title: '库存属性',
                    width: 90,
                    dataIndex: 'stockType'
                },
                {
                    title: '牌价',
                    width: 70,
                    dataIndex: 'showPrice'
                },
                {
                    title: '下浮率',
                    dataIndex: 'priceRate',
                    width: 70,
                    render: (text, record, index) => {
                        if (!priceRate[index]) {
                            return (<span>{'0%'}</span>)
                        } else {
                            return (<span>{priceRate[index] + '%'}</span>)
                        }
                    }
                },
                {
                    title: '下浮价',
                    dataIndex: 'xiaFuJia',
                    width: 70,
                    render: (text, record, index) => {
                        if (!xiaFuJia[index]) {
                            return (<span>{'0'}</span>)
                        } else {
                            return (<span>{xiaFuJia[index]}</span>)
                        }
                    }
                },
                {
                    title: '单位',
                    width: 50,
                    dataIndex: 'unit'
                },
                {
                    title: '分物流库存',
                    width: 100,
                    dataIndex: 'onhand',
                    render: (text, record, index) => {
                        if (!onhand[index]) {
                            return (<span>{record.noshowOnhand ? '*' : '0'}</span>)
                        } else {
                            return (<span>{record.noshowOnhand ? '*' : onhand[index]}</span>)
                        }
                    }
                },
                {
                    title: '本部库存',
                    width: 100,
                    dataIndex: 'cadreRepertory',
                    render: (text, record, index) => {
                        if (!cadreRepertory[index]) {
                            return (<span>{record.noshowOnhand ? '*' : '0'}</span>)
                        } else {
                            return (<span>{record.noshowOnhand ? '*' : cadreRepertory[index]}</span>)
                        }
                    }
                },
                {
                    title: '未发数量',
                    width: 90,
                    dataIndex: 'weiFaYunCount',
                    render: (text, record, index) => {
                        if (!weiFaYunCount[index]) {
                            return (<span>{'0'}</span>)
                        } else {
                            return (<span>{weiFaYunCount[index]}</span>)
                        }
                    }
                },
                {
                    title: '开单数量',
                    width: 100,
                    dataIndex: 'count',
                    render: (text, record, index) => {
                        return (<div>
                            <InputNumber disabled={xinzengShow || apiFlag}
                                         value={this.state.submitRows[index].count || 0} min={0}
                                         onChange={this.onChangeInputNumber.bind(this, record, index)}/>
                        </div>)
                    }
                },
                {
                    title: '装箱数',
                    width: 70,
                    dataIndex: 'packageQuantity'
                },
                {
                    title: <Tooltip title='产品内盒凑整数，请按照倍数订货'>内盒凑整数</Tooltip>,
                    width: 105,
                    dataIndex: 'minPackageQuantity'
                },
                {
                    title: '最大可接受数量',
                    width: 80,
                    dataIndex: 'maxAcceptQty',
                },
                {
                    title: <Tooltip title={lines}>生产周期（天）</Tooltip>,
                    width: 135,
                    dataIndex: 'productionCycle',
                    render: (text, record, index) => {
                        if (productionCycle.toString().includes("[")) {
                            //return (<span>{'0'}</span>)
                            return <Tooltip title="有库存生产需要天数/无库存天数">{productionCycle[index]}</Tooltip>
                        } else {
                            return (<span>{productionCycle[index]}</span>)
                        }
                    }
                },
                {
                    title: <Tooltip title="例：物流周期：[2,6]代表：有库存物流发货:2天，无库存:6天">物流周期（天）</Tooltip>,
                    width: 135,
                    dataIndex: 'day',
                    render: (text, record, index) => {
                        //console.log(day);
                        if (day.toString().includes("[")) {
                            // return (<span>{'0'}</span>)
                            return <Tooltip title="有库存物流发货天数/无库存天数">{day[index]}</Tooltip>
                        }
                        return (<span>{day[index]}</span>)
                    }
                },
                {
                    title: <Tooltip title="超最大可接受数量且库存不充足，显示待评审">参考到货期</Tooltip>,
                    width: 105,
                    dataIndex: 'date',
                    render: (text, record, index) => {
                        if (typeof text == 'string') {
                            if (text == '待评审') {
                                return (<span style={{color: 'red'}}>{text}</span>);
                            } else {
                                return text;
                            }
                        } else {
                            return (<span>{text || '0'}</span>)
                        }
                        // } else {
                        //     return (<span>{date[index]}</span>)
                        // }
                    }
                },
                // {
                //     title: '预计到货期',
                //     width: 105,
                //     dataIndex: 'predictArrivalDate',
                //     render: text => {
                //         if (typeof text == 'string') {
                //             return text
                //         } else {
                //             text ? new Date(text).format('yyyy-MM-dd') : ''
                //         }
                //     }
                // },
                {
                    title: '要求交期',
                    width: 125,
                    dataIndex: 'deliveryArrivalDate',
                    render: (text, record, index) =>
                        <Tooltip title="启用产能控制的产品可修改交期">
                            <div>
                                <DatePicker onChange={self.deliveryTimeonChange.bind(this, index)}
                                            format="YYYY-MM-DD"
                                            value={text ? moment(text) : null}
                                            disabled={xinzengShow || record.capacityControl != 1}
                                            disabledDate={disabledDeliveryDate}/>
                            </div>
                        </Tooltip>
                },
                {
                    title: '备注',
                    width: 150,
                    dataIndex: 'remark',
                    render: (text, record, index) => <div><Input defaultValue={text}
                                                                 maxLength={100}
                                                                 disabled={xinzengShow}
                                                                 value={this.state.submitRows[index].remark || ''}
                                                                 onChange={this.changeRemark.bind(this, record, index)}/>
                    </div>
                },
                {
                    title: '提货地点',
                    width: 150,
                    dataIndex: 'pickProAddress',
                    render: text => <span>{this.state.orgName}</span>
                },
                // {
                // 	title: '未发运数量',
                // 	width: 70,
                // 	dataIndex: 'unFaYunCount',
                // 	render: (text,record,index) => {
                // 		return (<div>
                // 					{!this.state.submitRows[index].faYunCount ? this.state.submitRows[index].count : (!this.state.submitRows[index].count  || this.state.submitRows[index].count == 0) ? 0 : (this.state.submitRows[index].count - this.state.submitRows[index].faYunCount )}
                // 				</div>)
                // 	}
                // },

                /*{
                    title: <Tooltip title='该功能用于产品分批发货，可自定义每一批产品的发货时间'>分批发运</Tooltip>,
                    dataIndex: 'orderProductPartList',
                    width: 85,
                    render: (text, record, index) => {
                        return (<div>
                            <img src={fenPi} alt='' title='分批发运' onClick={this.openModal.bind(this, record, index)}
                                 style={{width: 20}}/>
                            <Modal
                                visible={modalVisible}
                                title="分批发运"
                                onCancel={this.handleCancel2}
                                maskClosable={false}
                                width={1000}
                                style={{top: 20}}
                                footer={null}
                            >
                                <div>
                                    <Button onClick={this.handleAdd2}>添加行</Button>
                                    <Button onClick={this.saveFenPi.bind(this, record, index)}
                                            style={{marginLeft: 10}}>确认添加</Button>
                                    <Table {...fenPiFaYun} bordered style={{marginTop: 10}}/>

                                </div>
                            </Modal>
                        </div>)
                    }
                },*/

            ],
            rows: this.state.submitRows,
            rowSelection: {selectedRowKeys: selectedRowKeysOutside, onChange: self.onOutsideSelectChange}
        };
        const addProps = {
            rowKey: 'id',
            loading: loading,
            pageParam: {
                total: addTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange
            },
            columns: [
                // {
                // 	title:'图片',
                // 	dataIndex:'picUrl',
                // 	width:120,
                // 	render: text => text ? <div><img src={src+text} style={{height:50}}/></div> : ''
                // },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: 90,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>)
                        } else {
                            return (<span>{text}</span>)
                        }
                    }
                },
                {
                    title: '物料名称',
                    dataIndex: 'name',
                    width: 220,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>)
                        } else {
                            return (<span>{text}</span>)
                        }
                    }
                },
                {
                    title: '牌价',
                    dataIndex: 'showPrice',
                    width: 60,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null || record.orderManagerFlag == '' || record.orderManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>)
                        } else {
                            return (<span style={{color: '#d61518', height: 50}}>{'¥' + text}</span>)
                        }
                    }
                },
                {
                    title: '库存类型',
                    dataIndex: 'stockType',
                    width: 60,
                },
                {
                    title: '物料类别',
                    dataIndex: 'proBigName',
                    width: 220,
                    render: (text, record, index) => {
                        return <span>{`${record.proBigName}/${record.proMiddleName}/${record.proDetailName}`}</span>
                    }
                },
                // {
                //     title: '产能',
                //     dataIndex: 'capacityStatus',
                //     width: 40,
                //     render: (text, record, index) => {
                //         let a;
                //         switch (text) {
                //             case "0":
                //                 a = <span>🩶</span>;
                //                 break;
                //             case "1":
                //                 a = <span>💚</span>;
                //                 break;
                //             case "2":
                //                 a = <span>💛</span>;
                //                 break;
                //             case "3":
                //                 a = <span>❤️</span>;
                //                 break;
                //             default:
                //                 a = <span>🩶</span>;
                //                 break;
                //         }
                //         return <Tooltip placement="topLeft" title="💚正常;💛紧张;❤️严重不足;🩶无法获取"> {a} </Tooltip>
                //     },
                // },
                {
                    title: '历史开单量',
                    dataIndex: 'historyCount',
                    width: 70,
                },
                {
                    title: '操作',
                    dataIndex: 'save',
                    width: 150,
                    render: (text, record, index) => {
                        if (record.proMiddleType == '36201') {
                            return (
                                <span>属硬件类产品，请到【特殊订单】->订单类型选择【硬件类】进行下单</span>);
                        } else if (record.proMiddleType == '36202') {
                            return (
                                <span>属软件类产品，请到【特殊订单】->订单类型选择【软件类ZY】进行下单</span>);
                        } else if (record.proMiddleType == '36204') {
                            return (
                                <span>属软件类产品，请到【特殊订单】->订单类型选择【软件类WG】进行下单</span>);
                        } else if (record.proMiddleType == '36203') {
                            return (
                                <span>属软件类产品，请到【特殊订单】->订单类型选择【服务费类】进行下单</span>);
                        } else if (record.orderManagerFlag == '' || record.orderManagerFlag == null) {
                            return (<span>无开单权限，请联系【价格管理部】申请开通下单权限（申请特价后自动开通下单权限）</span>)
                        } else if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (
                                <span>经公司高层领导决定，对专属定制物料进行全面管控，若有需求，请发起定制申请</span>)
                        } else {
                            return (<Button style={{background: '#red'}} icon="plus"
                                            onClick={this.addSave.bind(this, record, index)}>添加</Button>)
                        }
                    }
                }
            ],
            rows: addRows,
            /*rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                onSelect: this.onSelectRadio,
                // type: 'radio',
            }*/
        };
        var orderCategory;
        if (orderData.Type == 'Y1') {
            orderCategory = '常规订单'
        }
        if (orderData.Type == 'Y2') {
            orderCategory = '项目订单'
        }
        if (orderData.Type == 'Y3') {
            orderCategory = '合作伙伴订单'
        }
        if (this.props.params.id == 6 || this.props.params.id == 9) {
            orderCategory = '合作伙伴订单'
        }
        const addProps2 = {
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: addTotal2,
                current: addSearchObj2.p,//当前页码
                pageSize: addSearchObj2.s,//当前分页数
                onChange: this.addPageChange2
            },
            columns: [
                {
                    title: '序号',
                    dataIndex: 'lineId',
                    width: 50
                },
                {
                    title: '区域',
                    dataIndex: 'area',
                    width: 100,
                },
                {
                    title: '省市',
                    dataIndex: 'province',
                    width: 200,
                },
                {
                    title: '提货组织',
                    dataIndex: 'orgName',
                    width: 100,
                },
            ],
            rows: addRows2,
            rowSelection: {
                selectedRowKeys: selectedRowKeys2,
                onChange: this.onSelectChange2,
                onSelect: this.onSelectRadio2,
                type: 'radio',
                // radio:false
            }
        };
        const addProps3 = {
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: addTotal3,
                current: addSearchObj3.p,//当前页码
                pageSize: addSearchObj3.s,//当前分页数
                onChange: this.addPageChange3
            },
            columns: [
                {
                    title: '大区',
                    dataIndex: 'area',
                    width: 100
                },
                {
                    title: '子公司',
                    dataIndex: 'province',
                    width: 100,
                },
                {
                    title: '子公司名称',
                    dataIndex: 'name',
                    width: 200,
                },
                {
                    title: '联系方式',
                    dataIndex: 'phone',
                    width: 100,
                },
                {
                    title: '收货人',
                    dataIndex: 'linkMan',
                    width: 100,
                },
                {
                    title: '收货地址',
                    dataIndex: 'address',
                    width: 100,
                },
            ],
            rows: addRows3,
            rowSelection: {
                selectedRowKeys: selectedRowKeys3,
                onChange: this.onSelectChange3,
                onSelect: this.onSelectRadio3,
                type: 'radio',
            }
        };

        const addProps4 = {
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: addTotal4,
                current: addSearchObj4.p,//当前页码
                pageSize: addSearchObj4.s,//当前分页数
                onChange: this.addPageChange4
            },
            columns: [
                {
                    title: '流程编码',
                    dataIndex: 'specCode',
                    width: 100
                },
                {
                    title: '项目报备名称',
                    dataIndex: 'projectName',
                    width: 100,
                },
                {
                    title: '开始日期',
                    dataIndex: 'startDate',
                    width: 100,
                    render: text => new Date(text).format('yyyy-MM-dd')
                },
                {
                    title: '结束日期',
                    dataIndex: 'endDate',
                    width: 100,
                    render: text => new Date(text).format('yyyy-MM-dd')
                },
                {
                    title: '承接业务员',
                    dataIndex: 'userName',
                    width: 100,
                },
                {
                    title: '行业客户',
                    dataIndex: 'zdCompany',
                    width: 100,
                }
            ],
            rows: addRows4,
            rowSelection: {
                selectedRowKeys: selectedRowKeys4,
                onChange: this.onSelectChange4,
                onSelect: this.onSelectRadio4,
                type: 'radio',
                // radio:false
            }
        };
        const addProps5 = {
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: addTotal5,
                current: addSearchObj5.p,//当前页码
                pageSize: addSearchObj5.s,//当前分页数
                onChange: this.addPageChange5
            },
            columns: [
                {
                    title: '具体物料规格',
                    children: [{
                        title: '对应物料编码',
                        dataIndex: 'proCode',
                        width: 100
                    },
                        {
                            title: '具体物料描述',
                            dataIndex: 'proDesc',
                            width: 100,
                        },
                        {
                            title: '特价数量',
                            dataIndex: 'count',
                            width: 100,
                        },
                        {
                            title: '开单数量',
                            dataIndex: 'orderQty',
                            width: 100,
                        },
                        {
                            title: '面价',
                            dataIndex: 'listPrice',
                            width: 100,
                        },
                        {
                            title: '合同价',
                            dataIndex: 'price',
                            width: 100,
                        }, {
                            title: '预计销量',
                            dataIndex: 'amount',
                            width: 100,
                        }, {
                            title: '剩余销量',
                            dataIndex: 'orderAmount',
                            width: 100,
                            render: (text, record, index) => {
                                return (<span>{record.amount - record.orderAmount}</span>)
                            }
                        }, {
                            title: '操作',
                            dataIndex: '',
                            width: 100,
                            render: (text, record, index) => {
                                if (record.proCode != "" && record.proCode != null) {
                                    return (<Button style={{background: '#red'}} icon="plus"
                                                    onClick={this.openAdd.bind(this, record.proCode)}>添加</Button>)
                                }
                            }
                        }]
                },
                {
                    title: '整体框架协议',
                    children: [{
                        title: '产品类别',
                        dataIndex: 'categoryDesc',
                        width: 100,
                    },
                        {
                            title: '类别编码',
                            dataIndex: 'categoryCode',
                            width: 100,
                        },
                        {
                            title: '合同下浮比例',
                            dataIndex: 'lowerRate',
                            width: 100,
                        }]
                }
            ],
            rows: addRows5,
        };

        return <div>
            <DmsTab options={opts} defaultKey={key}>
                {/*<Button onClick={this.resetView} style={{background:'#d61518', color: '#fff'}}>重置</Button>*/}
                <Button onClick={this.goBack.bind(this)} style={{float: 'right'}}>取消</Button>
                {/*<Tooltip title="无法保存时，请检查订单内容是否填写完整，如已添加物料行，请尝试修改开单数量。"
                         placement='bottom'
                         arrowPointAtCenter
                         visible={this.state.usable}
                ><Button style={{marginLeft: 10, float: 'right', display: orderSubmit3}} onClick={this.createHandler2}
                         disabled={this.state.usable}>保存</Button></Tooltip>*/}
                <Button style={{marginLeft: 10, float: 'right', display: orderSubmit3}} onClick={this.createHandler2}
                        disabled={this.state.usable}>保存</Button>
                <Button onClick={this.showModal}
                        style={{background: '#d61518', color: '#fff', float: 'right', display: orderSubmit4}}
                        disabled={this.state.usable}>提交</Button>
                <Modal title="注意"
                       visible={confirmvisible}
                       onOk={this.createHandler}
                       confirmLoading={confirmLoading}
                       onCancel={this.handleCancel5}
                >
                    <p>{"提交后将无法修改、删除订单，确认提交订单："}{this.state.getProCode}{"？请务必仔细核对订单数量、金额是否正确，避免输入错误影响产品发货"}</p>
                </Modal>
                <Button onClick={this.createHandler.bind(this, `${2}`)} style={{
                    background: '#d61518',
                    color: '#fff',
                    marginLeft: 10,
                    display: orderSubmit2,
                    float: 'right'
                }} disabled={this.state.usable}>提交客户审核</Button>
            </DmsTab>
            <div className="dms-table-box">
                <div className="Card-P">
                    <Row>
                        <Col span={6}>
                            <Card title="订单信息" bordered={false} noHovering={true}>
                                <p><label>要货单号：</label>
                                    <span>{this.state.getProCode || '-'}</span></p>
                                <p><label>订单编号：</label>
                                    <span>-</span></p>
                                <p><label>订单日期：</label>
                                    <span>{moment(parseInt(detailData.createdDate)).format('YYYY-MM-DD') || '-'}</span>
                                </p>
                                <p><label>订单类型：</label>
                                    <span>{orderCategory}</span></p>
                                <p><label>状态：</label>
                                    <span>{this.state.status || '-'}</span></p>
                            </Card>

                        </Col>
                        <Col span={6}>
                            <Card title="客户资料" bordered={false} noHovering={true}>
                                <p><label>经销商编号：</label>
                                    <span>{detailData.cusCode}</span></p>
                                <p><label>经销商名称：</label>
                                    <span>{detailData.cusName}</span></p>
                                <p><label>购货单位：</label>
                                    <span>{orderData.PurchaseUnit}</span></p>
                                <p><label>渠道：</label>
                                    <span>{orderData.channel}</span></p>
                                <p><label>业务员：</label>
                                    <span>{seller || '-'}</span></p>
                                <p><label>整单发货：</label>
                                    <span><Select value={this.state.wholeDelivery} style={{width: 100}}
                                                  onChange={this.wholeDeliveryChange.bind(this)}>
								<Option key={1} value={'Y'}>{'是'}</Option>
								<Option key={2} value={'N'}>{'否'}</Option>
                                </Select></span></p>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card title="信用情况" bordered={false} noHovering={true}>
                                <p><label>可用余额：</label>
                                    <span>{orderData.sxeAmount}</span></p>
                                <p><label>开单折扣率：</label>
                                    <span><InputNumber value={this.state.defDiscount}
                                                       onChange={this.changeDefDisCount.bind(this)}
                                                       style={{width: '150px'}} max={orderData.defDiscount}/></span></p>
                                <p><label>项目名称：</label>
                                    <span>{detailData.name || '-'}</span></p>
                                <p><label>质保金：</label>
                                    <span>-</span></p>
                                <p><label>终端单位名称：</label>
                                    <span>
							<Select
                                showSearch
                                optionFilterProp="children"
                                value={terminalMessage}
                                style={{width: 180}}
                                dropdownMatchSelectWidth={false}
                                disabled={apiFlag}
                                onSelect={this.terminalChange.bind(this)}>
								{(optionTerminal || '').map(function (ele, itm) {
                                    return <Option key={ele.id + ''}
                                                   value={ele.id + ''}>{ele.projectMsg} - {ele.seller}</Option>;
                                })}
							</Select>
						    </span></p>
                                <p><label>价格单号：</label>
                                    <span><Input onClick={this.openCity3.bind(this)} style={{width: 209}}
                                                 disabled={apiFlag}
                                                 value={this.state.guiShu1} /*disabled={this.state.teJiaShow}*//></span>
                                </p>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card title="合作伙伴订单属性" bordered={false} noHovering={true}>
                                <p><label>订单模式：</label>
                                    <span>
							<Select value={this.state.partnerOrderType} style={{width: 190}}
                                    onSelect={this.terminalChange2.bind(this)}>
								<Option key={1} value={'Default'}>{'默认订单'}</Option>
								<Option key={2} value={'Central Stock'}>{'中央库存订单'}</Option>
							</Select>
						</span></p>
                                <p><label>业务归属渠道：</label>
                                    <span>
							<Select value={this.state.businessChannel} style={{width: 163}}
                                    onChange={this.terminalChange3.bind(this)} disabled>
								<Option key={1} value={'CT'}>{'通讯能源'}</Option>
								<Option key={2} value={'DL'}>{'电力'}</Option>
								<Option key={3} value={'FX'}>{'全局'}</Option>
								<Option key={4} value={'GMJ'}>{'区域终端原建筑'}</Option>
                                <Option key={5} value={'PC'}>{'战略盘厂'}</Option>
                                <Option key={8} value={'OEM01'}>{'OEM大客户'}</Option>
                                <Option key={10} value={'VIP'}>{'合作伙伴'}</Option>
                                <Option key={10} value={'QYZD'}>{'区域终端'}</Option>
                                <Option key={10} value={'XNY'}>{'新能源'}</Option>
                                <Option key={10} value={'ZNPD'}>{'智能配电'}</Option>
							</Select>
						</span></p>
                                <p>
                                    <label>业务拉动渠道：</label>
                                    <span>
							<Select value={this.state.pullChannel} style={{width: 163}}
                                    onChange={this.pullChannelChange.bind(this)}>
								<Option key={1} value={'CT'}>{'网络能源'}</Option>
								<Option key={2} value={'DL'}>{'电力'}</Option>
								<Option key={3} value={'GMJ'}>{'区域终端原建筑'}</Option>
                                <Option key={4} value={'PC'}>{'战略盘厂'}</Option>
                                <Option key={6} value={'OEM01'}>{'OEM大客户'}</Option>
                                <Option key={8} value={'FX'}>{'分销'}</Option>
                                <Option key={10} value={'VIP'}>{'合作伙伴'}</Option>
							</Select>
						</span></p>
                                <p><label>收货省市：</label>
                                    <span><Input onClick={this.openCity.bind(this)} disabled={xinzengShow || apiFlag}
                                                 style={{width: 192}}
                                                 value={this.state.gatherCity}/></span></p>
                                <p><label>归属子公司：</label>
                                    <span><Input onClick={this.openCity2.bind(this)} style={{width: 179}}
                                                 disabled={xinzengShow || apiFlag}
                                                 value={this.state.subsidiaryName}/></span></p>
                                <p><label>出库单显示单价：</label>
                                    <span><Select value={this.state.deliveryShowprice} style={{width: 150}}
                                                  onChange={this.deliveryShowpriceChange.bind(this)}>
								<Option key={1} value={'Y'}>{'是'}</Option>
								<Option key={2} value={'N'}>{'否'}</Option>
                            </Select></span></p>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <hr style={{marginBottom: '7px'}}/>
                            <Card bordered={false} noHovering={true}>
                                <p><label>实际收货地址：</label>
                                    <Tooltip
                                        title="收货地址新增、修改或失效，请联系总部物流周春霞"
                                        placement='top'
                                        arrowPointAtCenter
                                    ><span>
							<Select
                                value={gatherRealityAddress2}
                                showSearch
                                optionFilterProp="children"
                                style={{width: 600}}
                                dropdownMatchSelectWidth={false}
                                onSelect={this.addressChange.bind(this)}
                            >
								{(optionAddress || '').map(function (ele, itm) {
                                    return <Option key={itm} value={ele.id + ''}>{ele.detailAddress}</Option>;
                                })}
							</Select>
                                    </span></Tooltip></p>
                                <p><label>备注：</label>
                                    <Input value={remark}
                                           maxLength={100}
                                           style={{width: 655}}
                                           onChange={this.remarkChange}/>
                                </p>
                            </Card>
                        </Col>
                        <Col span={12}>
                            <hr style={{marginBottom: '7px'}}/>
                            <Card bordered={false} noHovering={true}>
                                <p><label>联系人：</label>
                                    <span>{recipientName || '-'}</span><label
                                        style={{paddingLeft: '30px'}}>联系电话：</label>
                                    <span>{mobile || '-'}</span></p>
                                <p><span><label>客户订单号：</label>
                                    <Input value={customerOrderCode} style={{width: 200}}
                                           onChange={this.customerOrderCodeChange}
                                           disabled={apiFlag}/></span>
                                    <span style={{paddingLeft: '30px'}}> <label>客户项目信息：</label>
                                    <Input value={customerProjectMsg}
                                           style={{width: 200}}
                                           maxLength={15}
                                           onChange={this.customerProjectMsgChange}
                                           disabled={apiFlag}/> </span>
                                </p>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
            <div>
                <DmsTab className="white-bg no-border"
                        options={['订单商品（无特价：代表产品不在特价中，请仔细核对产品的系列是否与特价中的系列一致）']}
                        defaultKey={0}/>
                <div className="dms-table-box">
                    <div style={{marginBottom: 38}}>
                        <Button style={{float: 'left'}} onClick={this.searchHandler}
                                disabled={xinzengShow || id6 || apiFlag}>新增</Button>
                        <Button onClick={this.deleteHandler.bind(this)}
                                style={{marginLeft: 10, float: 'left'}} disabled={id6 || apiFlag}>删除</Button>
                        <Button onClick={this.downloadChange.bind(this)}
                                style={{marginLeft: 10, float: 'left'}} disabled={id6 || apiFlag}>下载模板</Button>
                        <Upload {...uploadParam}>
                            <Button style={{marginLeft: 10}} disabled={!this.state.orgName || id6 || apiFlag}>
                                <Icon type="upload"/>导入
                            </Button>
                        </Upload>
                        <Button style={{float: 'left', marginLeft: 10}} onClick={this.quickHandler}
                                disabled={id6 || (orgId == null) || apiFlag}>快捷录入</Button>
                    </div>
                    <TableView {...tableViewProps} />
                    <div className="order_amount" style={{marginTop: 20}}>
                        <p><span className="right">{'商品总金额：￥' + allPrice}</span></p>
                        <p><span className="right">{'优惠金额：￥' + cutPrice}</span></p>
                        <p><span className="right">{'实际总金额：￥' + realyPrice}</span></p>
                    </div>
                </div>
            </div>

            <Modal
                visible={visible}
                title={<span>选择物料（支持Enter回车查询，<span
                    style={{color: 'red'}}> 搜索不到产品？请尝试勾选退市产品</span>）</span>}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={1200}
                style={{top: 20}}
                footer={null}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={8}><label>物料名称/编号：</label><Input style={{width: 250}}
                                                                              value={this.state.name}
                                                                              onChange={this.nameChange}
                                                                              onKeyPress={this.keypress}/></Col>
                            <Col span={5}><label>产品分类：</label>
                                <Cascader style={{width: '130px'}} options={tree}
                                          value={cascaderValue}
                                          onChange={this.CascaderChange.bind(this)}
                                          onClick={this.CascaderClick.bind(this)}
                                          displayRender={this.CascaderRender.bind(this)}
                                          placeholder=""
                                          popupClassName="popupClass"
                                          showSearch={{filter: this.CascaderFilter}}
                                /></Col>
                            <Col span={4}><label>库存属性：</label>
                                <Select defaultValue="" style={{width: 100}} onChange={this.stockChange}>
                                    <Option value="">全部</Option>
                                    <Option value="0">库存</Option>
                                    <Option value="1">非库存</Option>
                                    <Option value="2">定制</Option>
                                    <Option value="3">专属定制</Option>
                                </Select>
                            </Col>
                            <Col span={2}><Checkbox onChange={this.tsChange}
                                                    disabled={ts_disabled}
                                                    checked={ts_checked}>退市产品</Checkbox></Col>
                            <Col span={3}><Tooltip placement="topLeft"
                                                   title="从您历史一年的开单产品中搜索"
                                                   arrowPointAtCenter><Checkbox onChange={this.lsChange}
                                                                                checked={ls_checked}>历史开单产品</Checkbox></Tooltip></Col>
                            <Col span={2}><Button onClick={this.getAddArray}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps} bordered style={{marginTop: 10}}/>
                    </section>
                    <Row type="flex" justify="center" style={{marginTop: 15}}>
                        <Col>
                            {/*<Button onClick={this.addSaveHandler.bind(this,`${1}`)}>确认并继续</Button>*/}
                            {/*<Button onClick={this.addSaveHandler.bind(this)}>确认</Button>*/}
                        </Col>
                    </Row>
                </div>
            </Modal>
            <Modal
                visible={visible4}
                title="选择价格单号"
                // onOk={this.handleOk3}
                onCancel={this.handleCancel6}
                maskClosable={false}
                width={1300}
                style={{top: 20}}
                footer={null}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={6}><label>流程编码：</label><Input style={{width: 200}}
                                                                         value={this.state.specCode}
                                                                         onChange={this.guiShuChange1}/></Col>
                            <Col span={6}><label>项目名称：</label><Input style={{width: 200}}
                                                                         value={this.state.projectName}
                                                                         onChange={this.guiShuChange2}/></Col>
                            <Col span={6}><label>业务员：</label><Input style={{width: 200}} value={this.state.userName}
                                                                       onChange={this.guiShuChange3}/></Col>
                            <Col span={6}><Button onClick={this.getAddArray4}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps4} bordered style={{marginTop: 10}}/>
                        <TableView {...addProps5} bordered/>
                    </section>
                    <Row type="flex" justify="center" style={{marginTop: 15}}>
                        <Col>
                            <Button onClick={this.addSaveHandler4}>确认</Button>
                        </Col>
                    </Row>
                </div>
            </Modal>
            <Modal
                visible={visible2}
                title="选择省市"
                onOk={this.handleOk3}
                onCancel={this.handleCancel3}
                maskClosable={false}
                width={1000}
                style={{top: 20}}
                footer={null}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={8}><label>省市：</label><Input style={{width: 200}} value={this.state.province}
                                                                     onChange={this.provinceChange.bind(this)}/></Col>
                            <Col span={8}><Button onClick={this.getAddArray2}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps2} bordered style={{marginTop: 10}}/>
                    </section>
                    <Row type="flex" justify="center" style={{marginTop: 15}}>
                        <Col>
                            <Button onClick={this.addSaveHandler2.bind(this)}>确认</Button>
                        </Col>
                    </Row>
                </div>
            </Modal>
            <Modal
                visible={visible3}
                title="选择归属子公司"
                onCancel={this.handleCancel4}
                maskClosable={false}
                width={1000}
                style={{top: 20}}
                footer={null}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={8}><label>归属子公司：</label><Input style={{width: 200}}
                                                                           value={this.state.guiShu}
                                                                           onChange={this.guiShuChange}/></Col>
                            <Col span={8}><Button onClick={this.getAddArray3}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps3} bordered style={{marginTop: 10}}/>
                    </section>
                    <Row type="flex" justify="center" style={{marginTop: 15}}>
                        <Col>
                            <Button onClick={this.addSaveHandler3}>确认</Button>
                        </Col>
                    </Row>
                </div>
            </Modal>

            <Modal visible={quickVisible}
                   title={"快捷录入"}
                   onOk={this.handleOk6}
                   onCancel={this.handleCancel7}
                   confirmLoading={quickLoading}
                   maskClosable={false} width={500}
            >
                <div><TextArea rows={10} placeholder='按[物料编码，数量]或[物料编码 数量]格式录入，多个换行录入'
                               value={quickString}
                               onChange={this.quickChange}></TextArea></div>
            </Modal>
        </div>

    }
}

export default withRouter(QualityAdd);



// WEBPACK FOOTER //
// ./src/routes/order/addPartners.js